import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import FilterModal from "../../../components/Modal/FilterModal";
import Select from "react-select";
import SalesCard from "../../../components/SalesCard/SalesCard";
import { Closed, Noimage } from "../../../common/imagePath";
import EditTax from "../../../components/Modal/EditTax";
import { Badge } from "react-bootstrap";
import SuspendedConfirmation from "../../../components/Modal/SuspendedConfirmation";
import { uploadAWS } from "../../../common/AWSHelper";
import { isEqual } from "lodash";
import {
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_SALES,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../common/Constant";
import FileInput from "../../../components/FormControls/FileInput";
import StoreAccountPaymentModal from "../../../components/Modal/StoreAccountPaymentModal";

import { toastError, toastSuccess } from "../../../common/Toast";
import CancelConfirmation from "../../../components/Modal/CancelConfirmation";
import SalesGiftCard from "../../../components/Modal/SalesGiftCard";
import Moment from "moment";
import SaleCompleteModal from "../../../components/Modal/SaleCompleteModal";
import ItemsDetailsModal from "../../../components/Modal/ItemsDetailsModal";
import { number } from "yup";
import { CListGroup } from "@coreui/react";

const ManageSale = () => {
  const paramObject = useParams();
  let updatedData = [];
  let updatePay = [];
  let originalPass = [];
  let matchedTagOptions;
  let outputMatchedOptions;
  let tagForMatching;

  const totalRef = useRef(0);
  const token = localStorage.getItem("Token") || "";
  const Clone = localStorage.getItem("Clone")
    ? localStorage.getItem("Clone")
    : 0;
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [formValues, setFormValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedcustomer, setSelectedCustomer] = useState("");
  const [custoptions, setCustOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [statenew, setStateNew] = useState([]);
  // const [netAmount,setNetAmount]=useState(0)
  const [entireSaleDiscount, setEntireSaleDiscount] = useState(0);
  const [discountInputValue, setDiscountInputValue] = useState(0);
  const [amountToSubtract, setAmountToSubtract] = useState(0);
  const [modal, setModal] = useState(false);
  const [method, setMethod] = useState(["Cash"]);
  const [dueAmount, setDueAmount] = useState(0);
  const [couponCode, setCouponCode] = useState("");
  const [payments, setPayments] = useState([]); // to keep track of all the payments made
  const [paymentCurrency, setPaymentCurrency] = useState("USD");

  const [deletedPaymentIndex, setDeletedPaymentIndex] = useState(-1);
  const [deletedPaymentIndexTax, setDeletedPaymentIndexTax] = useState(-1);
  const [select, setSelect] = useState("Sale");
  const [customFileUrl, setCustomFileUrl] = useState("");
  const [customFields, setCustomFields] = useState([]);
  const [customFieldSalesValues, setcustomFieldSalesValues] = useState([]);
  const [changeImagename, setChangeImagename] = useState(false);
  const [btnLoader, setBtnLoader] = useState({ SelectImage: false });
  const [ImageUrl, setImageUrl] = useState("");
  const [selectedCustomField, setSelectedCustomField] = useState("");
  const [selectCustomCheckBox, setSelectCustomCheckBox] = useState(false);
  const [selectedCustomImage, setSelectedCustomImage] = useState("");
  const [selectedCustomFile, setSelectedCustomFile] = useState("");
  const [selectedPayment, setSelectedPayment] = useState({
    id: 1,
    name: "Cash",
  });
  const [selectedLocation, setSelectedLocation] = useState(0);
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [customerAddress, setCustomerAddress] = useState();
  const [customerEmail, setCustomerEmail] = useState();
  const [comment, setComment] = useState("");
  const [saletype, setSaletype] = useState([]);
  const [paymentTypeDropdown, setPaymentTypeDropdown] = useState([]);
  const [saleTypeId, setSaleTypeId] = useState(1);
  const [selectedSaleOption, setselectedSaleOption] = useState("Sale");
  const [selectedDropDownValue, setSelectDropDownValue] = useState(1);
  const [taxXml, setTaxXml] = useState([]);
  const [xmltax, setXmlTax] = useState([]);
  const [reason, setReason] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [clickedValue, setClickedValue] = useState(0);
  const [customerName, setCustomerName] = useState();
  const [customerId, setcustomerId] = useState("");
  const [paidAmount, setPaidAmount] = useState("");
  const [isStoreAccountPaymentFlag, setIsStoreAccountPaymentFlag] = useState(0);
  const [isStoreAccountPayment, setIsStoreAccountPayment] = useState(false);
  const [runApi, setRunApi] = useState(false);

  const [totalQuantity, setTotalQuantity] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedCategoryForSearch, setSelectedCategoryForSearch] =
    useState(null);

  const [selectedPriceForSale, setSelectedPriceForSale] = useState(1);
  const [selectedTirePriceForSale, setSelectedTirePriceForSale] =
    useState(null);
  const [defaultSellingTierPriceList, setDefaultSellingTierPriceList] =
    useState([]);
  const [tireObject, setTireObject] = useState([]);

  const [commonDiscount, setCommonDiscount] = useState(0);
  const [itemTotal, setItemTotal] = useState(0);
  const [toggleItemsFilterSection, setToggleItemsFilterSection] =
    useState(false);
  console.log(runApi, "runApi");
  console.log(runApi, "runApi");
  const [accountSaleData, setAccountSaleData] = useState({
    InvoiceMessage: "",
    InvoiceNumber: "",
    InvoiceStatement: "",
    DueDate: "",
    Attachment: "",
    InvoiceDate: "",
  });

  console.log(typeof commonDiscount, "commonDiscount");
  console.log(typeof commonDiscount, "commonDiscount");
  const [tagsValue, setTagsValue] = useState([]);
  const [selectedtags, setSelectedtags] = useState("");
  const [term, setTerm] = useState([]);
  const [tag, setTag] = useState([]);
  const [todayDate, setTodayDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [changeFileName, setChangeFileName] = useState(false);
  const [FileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [btnFileLoader, setBtnFileLoader] = useState({ Receipt: false });
  const [checkboxes, setCheckboxes] = useState(0);
  const [isContentVisible, setIsContentVisible] = useState(true);
  const [itemsDetailsData, setItemsDetailsData] = useState();
  const [salesDeliveryData, setSalesDeliveryData] = useState();
  const [selectedSalesDeliveryData, setSelectedSalesDeliveryData] = useState();

  const [deliveryFees, setDeliveryFees] = useState(0);
  const [netAmountValue, setNetAmountValue] = useState(0);
  const [isChangedData, setIsChangedData] = useState(false);

  const [showEditStatement, setShowEditStatement] = useState(false);
  const [showEditInvoice, setShowEditInvoice] = useState(false);

  //accordian

  const [isAccordionOpen, setAccordionOpen] = useState(false);
  const [isAccordionOpenOne, setAccordionOpenOne] = useState(false);
  const toggleAccordion = () => {
    setAccordionOpen(!isAccordionOpen);
  };
  const [restirctedit, setRestrictEdit] = useState(0);

  const toggleAccordionOne = () => {
    setAccordionOpenOne(!isAccordionOpenOne);
  };

  //////

  //LocalStorage
  // const[localValues,setLocalValues] = useState();
  const [localValues, setLocalValues] = useState({});
  const [amount, setAmount] = useState(0);
  // const [netAmountVal,setNetAmountVal] = useState("0.00")

  console.log(accountSaleData, "invoice statemont");
  console.log(FileUrl, fileName, "FileUrl");

  // console.log("Clone-->", Clone);
  // const [accountSaleData, setAccountSaleData] = useState();
  // Terms Group DropDown
  let termOptions = [];
  const termDropDown = term.map((u, i) => {
    termOptions[i] = {
      label: u.Name,
      value: u.ID,
      actualValue: u.Value,
    };
  });

  console.log(statenew, "statenew selected data");
  // Tax Group DropDown
  let tagOptions = [];
  const tagDropDown = tag.map((u, i) => {
    tagOptions[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  //LSTotalAmount
  let LStotalAmt;

  if (paramObject.id === undefined) {
    LStotalAmt = JSON.parse(localStorage.getItem("saleDraft"));
    LStotalAmt = LStotalAmt?.inputDropdown?.reduce((acc, cur) => {
      acc += +cur.Total;
      return acc;
    }, 0);
  }
  console.log(LStotalAmt, "LStotalAmt196");
  let LSTQty;
  if (paramObject.id === undefined) {
    LSTQty = JSON.parse(localStorage.getItem("saleDraft"));
    LSTQty = LSTQty?.inputDropdown?.reduce((acc, cur) => {
      acc += +cur.itemquantity;
      return acc;
    }, 0);
    console.log("LSTQty", LSTQty);
  }

  // Calculate the total tax amount
  let totalTaxAmount = 0;

  console.log(typeof deliveryFees, "deliveryFees");
  console.log(taxXml, "taxXml186");
  console.log(totalTaxAmount, "totalTaxAmount");

  function calculateItemTax(total, taxPercent, stateLength) {
    return (total * taxPercent) / 100 / stateLength;
  }
  const [uniqueTaxItemCount, setUniqueTaxItemCount] = useState([]);
  function calculateOtherTax(total, taxPercent, stateLength, taxXml) {
    var a = (total * parseInt(taxPercent)) / 100;
    console.log(
      total,
      taxPercent,
      a / (1 + parseInt(uniqueTaxItemCount)),
      1 + parseInt(uniqueTaxItemCount),
      "tax194"
    );
    return (
      // (total * parseInt(taxPercent)) / 100 / (1 + parseInt(uniqueTaxItemCount))
      (total * parseInt(taxPercent)) / 100
    );
  }
  function calculateDeliveryTax(total, taxPercent) {
    console.log(total, taxPercent, "tax194");
    return (total * parseInt(taxPercent)) / 100;
  }
  useEffect(() => {
    const uniqueTaxItemIds = [
      ...new Set(
        taxXml
          ?.filter((item) => item?.TaxItemID !== null && item?.TaxItemID !== "")
          .map((item) => item.TaxItemID)
      ),
    ];
    console.log(uniqueTaxItemIds, "uniqueTaxItemIds");
    const uniqueTaxItemCount = uniqueTaxItemIds.length;
    setUniqueTaxItemCount(uniqueTaxItemCount);
    calculateItemTax();
    calculateOtherTax();
    calculateDeliveryTax();
  }, [statenew, taxXml, totalRef]);
  console.log(uniqueTaxItemCount, "tax194");
  console.log(totalRef.current, "totalRef.current");

  taxXml?.forEach((tax) => {
    if (tax.type === "globalTax") {
      totalTaxAmount += calculateOtherTax(
        // totalRef.current,
        paramObject.id === undefined
          ? Number(
              LStotalAmt == undefined ? 0 : LStotalAmt - commonDiscount
            ).toFixed(2)
          : Number(totalRef.current).toFixed(2),
        tax.TaxPercent,
        statenew.length,
        taxXml
      );
      console.log(totalTaxAmount, LStotalAmt, "totalTaxAmount237");
    } else if (tax.type === "itemTax") {
      totalTaxAmount += calculateItemTax(
        // totalRef.current,
        paramObject.id === undefined
          ? Number(
              LStotalAmt == undefined ? 0 : LStotalAmt - commonDiscount
            ).toFixed(2)
          : Number(totalRef.current).toFixed(2),
        tax.TaxPercent,
        statenew.length
      );
    } else if (tax.type === "deliveryTax") {
      totalTaxAmount += calculateDeliveryTax(
        // totalRef.current
        paramObject.id === undefined
          ? Number(
              LStotalAmt == undefined ? 0 : LStotalAmt - commonDiscount
            ).toFixed(2)
          : Number(totalRef.current).toFixed(2),
        tax.TaxPercent
      );
    }
  });

  let netAmount = (
    paramObject.id !== undefined
      ? parseFloat(isNaN(totalRef.current) ? 0 : totalRef.current) +
        parseFloat(isNaN(totalTaxAmount) ? 0 : totalTaxAmount) +
        parseFloat(isNaN(deliveryFees) ? 0 : deliveryFees)
      : parseFloat(
          isNaN(LStotalAmt - commonDiscount) ? 0 : LStotalAmt - commonDiscount
        ) +
        parseFloat(isNaN(totalTaxAmount) ? 0 : totalTaxAmount) +
        parseFloat(isNaN(deliveryFees) ? 0 : deliveryFees)
  ).toFixed(2);

  let netSubAmount = (
    paramObject.id === undefined
      ? parseFloat(isNaN(LStotalAmt) ? 0 : LStotalAmt)
      : parseFloat(isNaN(totalRef.current) ? 0 : totalRef.current)
  )
    //  + parseFloat(isNaN(totalTaxAmount) ? 0 : totalTaxAmount)
    .toFixed(2);

  console.log(totalTaxAmount, "totalTaxAmount");
  console.log(netAmount, "netAmount");
  console.log(netSubAmount, "netAmount");
  console.log(LStotalAmt, "LStotalAmt");
  // useEffect(()=>{

  //   const savedData = localStorage.getItem("saleDraft") || "";
  //   if (savedData && paramObject.id==undefined) {

  //     const parsedData = JSON.parse(savedData);
  //     console.log(parsedData?.subTotal, "parsedData?.subTotal")
  //     netSubAmount = parsedData?.subTotal
  //   }

  //   const x = { ...localValues, subTotal: netSubAmount,  Total: netAmount};
  //   setLocalValues(x);
  //   localStorage.setItem("saleDraft", JSON.stringify(x))

  // },[netSubAmount])

  console.log(deliveryFees, totalTaxAmount, totalRef.current, "456");
  const paymentTypeMap = {};
  paymentTypeDropdown.forEach((paymentType) => {
    paymentTypeMap[paymentType.ID] = paymentType.Paymenttypename;
  });

  // if(paramObject.id === undefined){
  //   console.log(paramObject, "setdata and get data paramObject")
  // } else{
  //   console.log(paramObject, "no set/Get paramObject")
  // }
  let navigate = useNavigate();
  const Id = localStorage.getItem("ID") || "";
  const loginUserId = localStorage.getItem("ID") || "";
  const Location = localStorage.getItem("Location") || "";

  const callback = (payload) => {
    console.log("callback allData => ", payload);
    if (payload != undefined && payload.length > 0) {
      const newItem = { ...payload[0], itemquantity: 1 };

      const existingItemIndex = statenew.findIndex(
        (item) =>
          item.ItemId === newItem.ItemId &&
          item.VariationId === newItem.VariationId
      );
      console.log(existingItemIndex, "itemindex");
      if (existingItemIndex != -1) {
        const existingItem = statenew[existingItemIndex];
        existingItem.itemquantity = existingItem.itemquantity + 1;
        existingItem.Price =
          selectedPriceForSale == undefined
            ? existingItem.UnitPrice
            : selectedPriceForSale === 1
            ? existingItem.UnitPrice
            : selectedPriceForSale === 3
            ? existingItem.RecallPrice
            : tireObject == "Tier1"
            ? existingItem.Tier1
            : tireObject == "Tier2"
            ? existingItem.Tier2
            : tireObject == "Tier3"
            ? existingItem.Tier3
            : tireObject == "Tier4"
            ? existingItem.Tier4
            : tireObject == "Tier5"
            ? existingItem.Tier5
            : 0;

        existingItem.Total = calculateTotal(
          selectedPriceForSale == undefined
            ? existingItem.UnitPrice
            : selectedPriceForSale === 1
            ? existingItem.UnitPrice
            : selectedPriceForSale === 3
            ? existingItem.RecallPrice
            : tireObject == "Tier1"
            ? existingItem.Tier1
            : tireObject == "Tier2"
            ? existingItem.Tier2
            : tireObject == "Tier3"
            ? existingItem.Tier3
            : tireObject == "Tier4"
            ? existingItem.Tier4
            : tireObject == "Tier5"
            ? existingItem.Tier5
            : 0,
          // existingItem.UnitPrice,
          existingItem.itemquantity,
          existingItem.itemdiscount
        );
        console.log(
          existingItem.UnitPrice,
          "existingItem.UnitPrice getItem total"
        );
        console.log(
          existingItem.RecallPrice,
          "existingItem.RecallPrice getItem total"
        );
        console.log(existingItem.Total, "existingItem.Total getItem total");

        const updatedDataNew = [...statenew];
        updatedDataNew[existingItemIndex] = existingItem;
        setStateNew(updatedDataNew);
        console.log("updatedData in callback=>", updatedDataNew);
        updatedData = updatedDataNew;
        // console.log("newItem = in callback=>", existingItem);
      } else {
        newItem.Price =
          selectedPriceForSale == undefined
            ? newItem.UnitPrice
            : selectedPriceForSale === 1
            ? newItem.UnitPrice
            : selectedPriceForSale === 3
            ? newItem.RecallPrice
            : tireObject == "Tier1"
            ? newItem.Tier1
            : tireObject == "Tier2"
            ? newItem.Tier2
            : tireObject == "Tier3"
            ? newItem.Tier3
            : tireObject == "Tier4"
            ? newItem.Tier4
            : tireObject == "Tier5"
            ? newItem.Tier5
            : 0;

        setStateNew([...statenew, newItem]);
        updatedData = statenew.concat(newItem); // add the new item to updatedData
        // console.log("newItem", newItem);
      }
      console.log("newItem ==>", newItem);
      updateTotal(updatedData); // pass updatedData to updateTotal()
    }

    payload = "";
    console.log("allData12", statenew);
  };

  const callbackaccount = (payload) => {
    console.log(payload, "payloads");
    // payload[0] = { ...payload[0], Amount: 0 };
    const existingItemIndex = statenew.findIndex(
      (item) => item?.ItemId == payload[0].ItemId
    );

    console.log(existingItemIndex, "indexing");

    if (existingItemIndex == -1) {
      setStateNew([...statenew, payload[0]]);
    }
  };

  const callbackItemGrid = (payload) => {
    // console.log("payload=>", payload); // Loop over each item in the payload array
    payload.forEach((newItem) => {
      // Find the index of the item in the statenew array that has the same ItemId
      // const index = statenew.findIndex(
      //   (i) => i.VariationId === item.VariationId
      // ); // If the item exists in the statenew array, increment the itemquantity by 1

      // if (index !== -1) {
      //   statenew[index].itemquantity += 1;
      // } else {
      //   // Otherwise, add the item with itemquantity 1 to the statenew array
      //   statenew.push({ ...item, itemquantity: 1 });
      // }

      const existingItemIndex = statenew.findIndex(
        (item) =>
          item.VariationId === newItem.VariationId &&
          item.ItemId === newItem.ItemId
      );
      // if (existingItemIndex !== -1) {
      //   const existingItem = statenew[existingItemIndex];
      //   existingItem.itemquantity += 1;
      //   existingItem.Total = calculateTotal(existingItem.UnitPrice, existingItem.itemquantity, existingItem.itemdiscount);

      //   const updatedDataNew = [...statenew];
      //   updatedDataNew[existingItemIndex] = existingItem;
      //   updatedData = updatedDataNew;

      // } else {
      //   // Otherwise, add the item with itemquantity 1 to the statenew array
      //   statenew.push({ ...newItem, itemquantity: 1, Total: calculateTotal(newItem.CostPrice, 1, 0) });

      //   updatedData = statenew.concat({ ...newItem, itemquantity: 1, Total: calculateTotal(newItem.UnitPrice, 1, 0) });
      // }

      if (existingItemIndex != -1) {
        const existingItem = statenew[existingItemIndex];
        existingItem.itemquantity = existingItem.itemquantity + 1;
        existingItem.Price =
          selectedPriceForSale == undefined
            ? existingItem.UnitPrice
            : selectedPriceForSale === 1
            ? existingItem.UnitPrice
            : selectedPriceForSale === 3
            ? existingItem.RecallPrice
            : tireObject == "Tier1"
            ? existingItem.Tier1
            : tireObject == "Tier2"
            ? existingItem.Tier2
            : tireObject == "Tier3"
            ? existingItem.Tier3
            : tireObject == "Tier4"
            ? existingItem.Tier4
            : tireObject == "Tier5"
            ? existingItem.Tier5
            : 0;

        existingItem.Total = calculateTotal(
          selectedPriceForSale == undefined
            ? existingItem.UnitPrice
            : selectedPriceForSale === 1
            ? existingItem.UnitPrice
            : selectedPriceForSale === 3
            ? existingItem.RecallPrice
            : tireObject == "Tier1"
            ? existingItem.Tier1
            : tireObject == "Tier2"
            ? existingItem.Tier2
            : tireObject == "Tier3"
            ? existingItem.Tier3
            : tireObject == "Tier4"
            ? existingItem.Tier4
            : tireObject == "Tier5"
            ? existingItem.Tier5
            : 0,
          // existingItem.UnitPrice,
          existingItem.itemquantity,
          existingItem.itemdiscount
        );

        const updatedDataNew = [...statenew];
        updatedDataNew[existingItemIndex] = existingItem;
        setStateNew(updatedDataNew);
        console.log("updatedData in callback=>", updatedDataNew);
        updatedData = updatedDataNew;
        // console.log("newItem = in callback=>", existingItem);
      } else {
        newItem.Price =
          selectedPriceForSale == undefined
            ? newItem.UnitPrice
            : selectedPriceForSale === 1
            ? newItem.UnitPrice
            : selectedPriceForSale === 3
            ? newItem.RecallPrice
            : tireObject == "Tier1"
            ? newItem.Tier1
            : tireObject == "Tier2"
            ? newItem.Tier2
            : tireObject == "Tier3"
            ? newItem.Tier3
            : tireObject == "Tier4"
            ? newItem.Tier4
            : tireObject == "Tier5"
            ? newItem.Tier5
            : 0;

        statenew.push({
          ...newItem,
          itemquantity: 1,
          Total: calculateTotal(
            selectedPriceForSale == undefined
              ? newItem.UnitPrice
              : selectedPriceForSale === 1
              ? newItem.UnitPrice
              : selectedPriceForSale === 3
              ? newItem.RecallPrice
              : tireObject == "Tier1"
              ? newItem.Tier1
              : tireObject == "Tier2"
              ? newItem.Tier2
              : tireObject == "Tier3"
              ? newItem.Tier3
              : tireObject == "Tier4"
              ? newItem.Tier4
              : tireObject == "Tier5"
              ? newItem.Tier5
              : 0,
            1,
            0
          ),
        });
        updatedData = statenew.concat({
          ...newItem,
          itemquantity: 1,
          Total: calculateTotal(newItem.Price, 1, 0),
        });

        // setStateNew([...statenew, newItem]);
        // updatedData = statenew.concat(newItem); // add the new item to updatedData
        // console.log("newItem", newItem);
      }
      console.log("newItem ==>", newItem);
      updateTotal(updatedData); // pass updatedData to updateTotal()
    });

    // setStateNew(updatedData);
    setStateNew([...statenew]);
    updateTotal(statenew);
  };

  // For tax Calculationnn
  const [taxData, setTaxData] = useState([]);
  const [globalTaxData, setGlobalTaxData] = useState([]);

  const callbackHandleEditTax = (payload, index) => {
    console.log("tax function run  1122");

    if (paramObject.id === undefined) {
      const x = { ...localValues, taxArray: payload };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    } else {
    }
    setTaxData([...payload]);
    if (payload.some((item) => item.type === "globalTax")) {
      setGlobalTaxData(payload);
    }
  };
  const [filteredTaxData, setFilteredTaxData] = useState([]);
  console.log("taxData::>>", taxData);
  console.log("accountSaleData-->", accountSaleData);

  useEffect(() => {
    if (paramObject.id > 0 && globalTaxData.length == 0) {
      const filteredGlobalTaxData = taxData.filter(
        (el) => el.type === "globalTax"
      );
      setGlobalTaxData(filteredGlobalTaxData);
      console.log("filteredGlobalTaxData", filteredGlobalTaxData);
    }
    // filterTaxData();
    const areIDsEqual = statenew.every((item) =>
      taxData.some(
        (tax) =>
          item.ItemId === tax.TaxItemID &&
          item.VariationId === tax.TaxVariationID
      )
    );
    if (areIDsEqual) {
      if (taxData !== "") {
        const filteredTaxData = taxData.filter(
          (item) => item.type !== "globalTax"
        );
        setTaxXml(filteredTaxData);
      }
    } else {
      if (taxData !== "") {
        const hasGlobalTax = taxXml.some((item) => item.type === "globalTax");
        if (hasGlobalTax) {
          setTaxXml(taxData);
        } else {
          if (taxXml != "") {
            setTaxXml([...taxXml, ...globalTaxData]);
          } else {
            setTaxXml([...taxXml, ...taxData]);
          }
        }
      }
    }
  }, [taxData, statenew]);

  console.log("globalTaxData::>>", globalTaxData);

  const callback4 = (payload) => {
    setStateNew([...statenew, payload]);
    const giftcardvalue = payload.UnitPrice;
    totalRef.current = giftcardvalue;

    if (isNaN(giftcardvalue)) {
      giftcardvalue = 0;
    }

    Compairamount = giftcardvalue;
    setDueAmount(Compairamount);
  };
  console.log("taxXml", taxXml);
  const callbackDelivery = (payload, mappedItem) => {
    console.log(payload, "payload465");
    const deliveryTaxAvailable = taxData.some(
      (item) => item.type === "deliveryTax"
    );

    const deliveryTaxXmlTaxAvailable = taxXml.some(
      (item) => item.type === "deliveryTax"
    );
    // console.log("deliveryTaxAvailable", deliveryTaxAvailable);
    if (deliveryTaxAvailable && deliveryTaxXmlTaxAvailable) {
      const updatedTaxData = taxData.filter(
        (item) => item.type !== "deliveryTax"
      );

      const updatedTaxXmldata = taxXml.filter(
        (item) => item.type != "deliveryTax"
      );
      // console.log("updatedTaxData::>>", updatedTaxData);
      setTaxData([...updatedTaxData, ...mappedItem]);
      setTaxXml([...updatedTaxXmldata, ...mappedItem]);
    } else {
      setTaxData([...taxData, ...mappedItem]);
      setTaxXml([...taxXml, ...mappedItem]);
    }
    if (payload == "CancelDelivery") {
      setSalesDeliveryData({});
      setDeliveryFees(0);

      setIsChangedData(true);
    } else {
      setDeliveryFees(payload.DeliveryFees);
      setSalesDeliveryData(payload);
      console.log(payload, "payload");

      // netAmount = (
      //   parseFloat(totalRef.current) +
      //   parseFloat(totalTaxAmount) +
      //   parseFloat(payload.DeliveryFees ? payload.DeliveryFees : 0)
      // ).toFixed(2);

      let netAmount = (
        parseFloat(isNaN(totalRef.current) ? 0 : totalRef.current) +
        parseFloat(isNaN(totalTaxAmount) ? 0 : totalTaxAmount) +
        parseFloat(isNaN(payload.DeliveryFees) ? 0 : payload.DeliveryFees)
      ).toFixed(2);

      setNetAmountValue(netAmount);
      setIsChangedData(false);
    }
  };

  console.log(taxData, taxXml, "taxData554");

  function calculateTotal(UnitPrice, itemquantity, itemdiscount) {
    if (isNaN(UnitPrice)) {
      UnitPrice = 0;
    }
    if (isNaN(itemquantity)) {
      itemquantity = 0;
    }
    if (isNaN(itemdiscount)) {
      itemdiscount = 0;
    }
    const totalPrice = UnitPrice * itemquantity * (1 - itemdiscount / 100);

    return totalPrice;
  }

  //dropdown
  // Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     },
  //   }),
  // };
  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      color: "#000",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      color: state.isActive ? "#000" : "#000",
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        color: "#000",
        backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
      },
    }),
  };

  const options = custoptions.map((option) => ({
    value: option.Id,
    label:
      option.CompanyName +
      "(" +
      (option.FirstName + " " + option.LastName) +
      ")",
    address: option.Address1,
    email: option.Email,
  }));

  const handleSelectChange = (event) => {
    console.log(event, "536");
    if (event != undefined) {
      if (paramObject.id === undefined) {
        let x = { ...localValues, dropdownCustomers: event };
        setLocalValues(x);
        localStorage.setItem("saleDraft", JSON.stringify(x));
      }
    }
    setCustomerEmail(event?.email);
    setSelectedOption(event);
    setcustomerId(event.value);

    setLoading(true);
    axios
      .get(
        `${config.customersBaseUrl}/customers/customerdetailforlabel?id=${event.value}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        if (
          response.data.ResponseData[0] != undefined &&
          response.data.ResponseData[0] != null
        ) {
          let customerData = response?.data?.ResponseData[0];
          setSelectedCustomer(customerData);
          console.log(customerData, "customerData1234");
          let customerAddress =
            customerData.Address1 +
            " " +
            customerData.Address2 +
            ",\r\n" +
            customerData.City +
            ",\r\n" +
            customerData?.StateProvince +
            ",\r\n" +
            customerData.Country +
            ".\r\n" +
            customerData.Zip;
          setCustomerAddress(customerAddress);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleCustomerDropdownChange = (cId) => {
    axios
      .get(
        `${config.customersBaseUrl}/customers/customerdetailforlabel?id=${cId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        if (
          response.data.ResponseData[0] != undefined &&
          response.data.ResponseData[0] != null
        ) {
          let customerData = response.data.ResponseData[0];
          setSelectedCustomer(customerData);
          console.log(customerData, "customerData1234");
          let customerAddress =
            customerData.Address1 +
            " " +
            customerData.Address2 +
            ",\r\n" +
            customerData.City +
            ",\r\n" +
            customerData.StateProvince +
            ",\r\n" +
            customerData.Country +
            ".\r\n" +
            customerData.Zip;
          setCustomerAddress(customerAddress);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  //Persisting the data in the UI using LocalStorage

  let salesTypeDropdownOption = [];
  const RolesDropdown = saletype.map((u, i) => {
    salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
  });

  const BindPageDropdown = () => {
    //  sale type
    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setSaletype(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      }); // PaymentType Dropdown List

    // Accounting Terms Drop Down Axios Call
    axios
      .get(`${config.generalBaseUrl}/generals/termsddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(true);
        setTerm(res.data.ResponseData);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });

    // Accounting Tags Drop Down Axios Call
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(true);
        setTag(res.data.ResponseData);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });

    // custom field getall
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/customfieldgetall?saleid=${loginUserId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const responseData = response.data.ResponseData;
        if (responseData.length !== 0) {
          setCustomFields(responseData);
        }

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    // payment dropdown
    axios
      .get(`${config.generalBaseUrl}/generals/paymentdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setPaymentTypeDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log("Error: ", err); // setLoading(false);
      });

    // categories
    axios
      .get(`${config.categoriesBaseUrl}/categories?filtertext=${""}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedCategory(res.data.ResponseData);
      });

    // customer drop down
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setCustOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const BindInvoiceDropdown = (pSaleTypeID) => {
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/autogenerateinvoicenumber?typeid=${
          pSaleTypeID > 0 ? pSaleTypeID : selectedDropDownValue
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        let invoiceNumber = res.data.ResponseData[0].InvoiceNumber;
        setAccountSaleData((prevValues) => ({
          ...prevValues,
          ["InvoiceNumber"]: invoiceNumber,
        }));
      });
    // }
  };

  const handleClick = () => {
    setShowEditStatement(true);
  };

  const handleClickEdit = () => {
    setShowEditInvoice(true);
  };

  const AddMessageStatement = (e) => {
    // console.log("eeeearrrrrrr", e);
    e.preventDefault();
    // console.log(e.target[0].value, "eeeeeeeeeeeeeeeeeeeeeee");

    handleChangeAccountSalesData(e.target[0].value, "InvoiceStatement");

    setShowEditStatement(false);

    // callback(valueOfInput);
  };

  const AddMessageInvoice = (e) => {
    console.log("eeeearrrrrrr", e.target[0].value);
    e.preventDefault();
    // console.log(e.target[0].value, "eeeeeeeeeeeeeeeeeeeeeee");

    handleChangeAccountSalesData(e.target[0].value, "InvoiceMessage");

    setShowEditInvoice(false);

    // callback(valueOfInput);
  };

  const cancelEdit = () => {
    setShowEditStatement(false);
  };

  console.log(deliveryFees, "deliveryFees874");

  const BindSalesDetails = () => {
    // setLoading(true);

    if (paramObject.id > 0 || Clone > 0) {
      setLoading(true);
      let paramid = paramObject.id > 0 ? paramObject.id : Clone;
      // Find By ID for sales
      localStorage.removeItem("Clone");
      axios
        .get(
          `${config.salesconfigBaseUrl}/sales/findbyid?id=${paramid}`,

          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          setIsReadOnly(false);
          console.log("Console From Sales ==>: ", res.data.ResponseData);
          const SuspendedData = res.data.ResponseData.unSuspendData[0];
          const PaymentData = res.data.ResponseData.paymentData;
          const TaxData = res.data.ResponseData.TaxData;
          const SalesItem = res.data.ResponseData.SalesItems;
          console.log(SalesItem, "salesitem");
          const CustomerDetails = res.data.ResponseData.CustomerDetails[0];
          console.log(CustomerDetails, "CustomerDetails");
          const SalesCustomFiledData =
            res.data.ResponseData.SalesCustomFiledData;
          const SalesDeliveryDetails =
            res.data.ResponseData.SalesDeliveryDetails[0];

          console.log(SalesDeliveryDetails, "SalesDeliveryDetails");

          setAccountSaleData(SuspendedData);
          console.log("accountSaleData-->", accountSaleData);
          setselectedSaleOption(SuspendedData.SalesType);
          setPaymentAmount(SuspendedData.total);
          setSelectDropDownValue(SuspendedData.Type);
          setRestrictEdit(SuspendedData.RestrictEdit);
          setSaleTypeId(SuspendedData.Type);
          setSelectedLocation(SuspendedData.Locationid);
          setCustomFields(SalesCustomFiledData);
          setSelectedSalesDeliveryData(SalesDeliveryDetails);
          setSalesDeliveryData(SalesDeliveryDetails);

          setDeliveryFees(SalesDeliveryDetails?.DeliveryFees);

          const paymentAmounts = PaymentData.map((payment) =>
            parseFloat(payment.Paymentamount)
          );
          const totalPaidAmount = paymentAmounts?.reduce(
            (acc, curr) => acc + curr,
            0
          );
          setPaidAmount(totalPaidAmount.toFixed(2));
          const mappedSaleItems = SalesItem.map((item) => {
            const mappedItem = {
              SaleItemID: Clone > 0 ? 0 : item.SaleItemID,
              ItemId: item.ItemId,
              SaleId: Clone > 0 ? 0 : Clone,
              UnitPrice: parseFloat(item.UnitPrice),
              Price: parseFloat(item.Price),
              RecallPrice: parseFloat(item.RecallPrice),
              ItemName: item.Items,
              itemquantity: parseFloat(item.itemquantity),
              itemdiscount: parseFloat(item.itemdiscount),
              CostPrice: parseFloat(item.CostPrice),
              Ischecked: item.Ischecked,
              Total: parseFloat(item.Total),
              Module: item.Module,
              Itemkitid: item.ItemKitId,
              VariationName: item.VariationName,
              // locationid: selectedLocation,
              locationid: Location,
              ItemCurrentQuantity: parseFloat(item.ItemCurrentQuantity),
              VariationQuantity: parseFloat(item.VariationQuantity),
              Description: item.Description,
              VariationId: item.VariationId,
              AttributeId: item.AttributeId,
              CategoryID: item.CategoryID,
              CategoryName: item.CategoryName,
              Itemnumber: item.Itemnumber,
              Allowaltdescription: item.Allowaltdescription,
              IsItemserialnumber: item.IsItemserialnumber,
              RecallPrice: item.RecallPrice,
              Tier1: item.Tier1,
              Tier2: item.Tier2,
              Tier3: item.Tier3,
              Tier4: item.Tier4,
              Tier5: item.Tier5,
            };
            return mappedItem;
          });
          setStateNew(mappedSaleItems);
          console.log(SalesItem, "SalesItem");
          console.log(deliveryFees, "deliveryFees");
          // console.log(mappedSaleItems, "mappedSaleItems 258")

          const totalItemQuantity = mappedSaleItems.reduce(
            (a, v) => (a = a + v.itemquantity),
            0
          );
          setTotalQuantity(totalItemQuantity);

          setCommonDiscount(SuspendedData.Discountentiresale);
          setReason(SuspendedData.Discountreason);
          const totalValue = parseFloat(SuspendedData.Subtotal);
          totalRef.current = parseFloat(totalValue).toFixed(2);

          // Setting the Amount Due
          const Compairamount = SuspendedData.AmountDue;
          setDueAmount(parseInt(Compairamount).toFixed(2));

          // Setting the Comment
          const commentValue = SuspendedData.Comments;
          setComment(commentValue || "");

          // setting the Suppliers Id
          setCustomerAddress(SuspendedData.BillingAddress);
          setCustomerEmail(SuspendedData?.EmailAddress);
          setcustomerId(SuspendedData.Customer);
          setSelectedOption(SuspendedData.Customer);
          setCustomerName(SuspendedData.Name);
          setSelectedCustomer(CustomerDetails ? CustomerDetails : []);
          const TaxTypeMap = [];
          TaxData.forEach((taxXml) => {
            TaxTypeMap[taxXml.ID] = taxXml.Name;
          });
          // setTaxXml(TaxData);
          console.log(customerEmail, "customerEmail");

          const mappedReceivingItems = TaxData.map((item) => {
            const mappedItem = {
              TaxID: item.ID,
              TaxName: item.TaxName,
              TaxPercent: item.TaxPercent,
              type: item.type,
              TaxItemID: parseInt(item.TaxItemID),
              TaxVariationID: parseInt(item.TaxVariationID),
            };
            return mappedItem;
          });
          setTaxData(mappedReceivingItems);
          setTaxXml(mappedReceivingItems);
          // setTaxData(TaxData);
          // (TaxData);

          let totalTaxAmountEdit = 0;
          TaxData.forEach((tax) => {
            totalTaxAmountEdit +=
              (parseFloat(totalValue).toFixed(2) * tax.TaxPercent) / 100;
          });

          let fees =
            SalesDeliveryDetails?.DeliveryFees > 0
              ? SalesDeliveryDetails?.DeliveryFees
              : 0;
          // netAmount = (
          //   parseFloat(totalValue) +
          //   parseFloat(totalTaxAmountEdit) +
          //   parseFloat(fees)
          // ).toFixed(2);

          let netAmount = (
            parseFloat(isNaN(totalValue) ? 0 : totalValue) +
            parseFloat(isNaN(totalTaxAmountEdit) ? 0 : totalTaxAmountEdit) +
            parseFloat(isNaN(fees) ? 0 : fees)
          ).toFixed(2);

          setNetAmountValue(netAmount);

          // setSelectedOption(customersName);
          const paymentTypeMap = {};
          PaymentData.forEach((payment) => {
            paymentTypeMap[payment.ID] = payment.Paymenttypename;
          });

          setPayments(PaymentData);
          setSelectedPayment(PaymentData.Paymenttypename);
          setPaymentTypeDropdown(PaymentData);

          // for bind the tags values
          let selecttags = SuspendedData.TagId;
          console.log("SuspendedData", SuspendedData);

          if (selecttags.length > 0) {
            axios
              .get(`${config.tagBaseUrl}/tags/tagsdropdown`, {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                  "Access-Control-Allow-Origin": "*",
                  Authorization: token,
                },
              })
              .then((res) => {
                // console.log("::>>>", res);
                tagOptions = res.data.ResponseData;

                if (selecttags.length > 0) {
                  tagOptions.map((selectManufacturer) => {
                    const splitSelectedTags = selecttags.split(",");
                    var splitSelectedTagsnumbers = splitSelectedTags.map(
                      function (str) {
                        return parseInt(str);
                      }
                    );

                    setSelectedtags(splitSelectedTagsnumbers);
                  });
                }
              });
          }

          outputMatchedOptions = matchedTagOptions.map(({ ID, Name }) => ({
            label: Name,
            value: ID,
          }));

          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  };

  // console.log("Selected Customer:",selectedcustomer)

  useEffect(() => {
    // Bind all dropdown for loading page
    BindPageDropdown();

    // Bind Sales Details
    BindSalesDetails();
  }, []);

  useEffect(() => {
    if (
      selectedDropDownValue != 4 &&
      (paramObject.id == undefined || paramObject.id == 0)
    ) {
      BindInvoiceDropdown();
    }
  }, [selectedDropDownValue]);

  // For the Price change
  const handlePriceChange = (index, value) => {
    updatedData = [...statenew];
    // updatedData[index] = { ...updatedData[index], UnitPrice: Number(value), Price: Number(value) };
    updatedData[index] = {
      ...updatedData[index],
      Price: value == 0 ? "" : Number(value),
    };

    let total = calculateTotal(
      // (selectedPriceForSale === 1 ? (updatedData[index].UnitPrice) :
      //   selectedPriceForSale === 3 ? (updatedData[index].RecallPrice) :

      //     tireObject == "Tier1" ? updatedData[index].Tier1 :
      //       tireObject == "Tier2" ? updatedData[index].Tier2 :
      //         tireObject == "Tier3" ? updatedData[index].Tier3 :
      //           tireObject == "Tier4" ? updatedData[index].Tier4 :
      //             tireObject == "Tier5" ? updatedData[index].Tier5 : 0),

      //updatedData[index].UnitPrice,
      updatedData[index].Price,
      updatedData[index].itemquantity,
      updatedData[index].itemdiscount
    );
    updatedData[index] = { ...updatedData[index], Total: Number(total) };

    console.log("updatedData ===>", updatedData);
    setStateNew(updatedData);

    updateTotal(updatedData);
  };

  const [validationErrors, setValidationErrors] = useState([]);
  // For handling the Quantity Change
  const handleQuantityChange = (index, value) => {
    updatedData = [...statenew];

    // Verify current qty is less then or not
    let itemCurrentQuantity = updatedData[index].ItemCurrentQuantity;
    // if (value === "" || Number(value) <= itemCurrentQuantity) {

    // remove error message from the use state
    const newValidationErrors = [...validationErrors];
    newValidationErrors[index] = "";
    setValidationErrors(newValidationErrors);

    // Update quantity from the use state
    updatedData[index] = {
      ...updatedData[index],
      itemquantity: value == 0 ? "" : Number(value),
    };

    let total = calculateTotal(
      // (selectedPriceForSale === 1 && (updatedData[index].UnitPrice),
      //   selectedPriceForSale === 3 && (updatedData[index].RecallPrice),

      //   tireObject == "Tier1" ? updatedData[index].Tier1 :
      //     tireObject == "Tier2" ? updatedData[index].Tier2 :
      //       tireObject == "Tier3" ? updatedData[index].Tier3 :
      //         tireObject == "Tier4" ? updatedData[index].Tier4 :
      //           tireObject == "Tier5" ? updatedData[index].Tier5 : 0),

      // updatedData[index].UnitPrice,
      updatedData[index].Price,
      updatedData[index].itemquantity,
      updatedData[index].itemdiscount
    );
    updatedData[index] = { ...updatedData[index], Total: Number(total) };

    setStateNew(updatedData);
    updateTotal(updatedData);

    //    } else {
    //   // add error message from the use state
    //   const newValidationErrors = [...validationErrors];
    //   newValidationErrors[index] =
    //     "Value must not exceed " + itemCurrentQuantity;
    //   setValidationErrors(newValidationErrors);
    // }
  };

  // For Handling the discount Change
  const handleDiscountChange = (index, value) => {
    updatedData = [...statenew];
    updatedData[index] = {
      ...updatedData[index],
      itemdiscount: value == 0 ? "" : Number(value),
    };

    let total = calculateTotal(
      // (selectedPriceForSale === 1 && (updatedData[index].UnitPrice),
      //   selectedPriceForSale === 3 && (updatedData[index].RecallPrice),

      //   tireObject == "Tier1" ? updatedData[index].Tier1 :
      //     tireObject == "Tier2" ? updatedData[index].Tier2 :
      //       tireObject == "Tier3" ? updatedData[index].Tier3 :
      //         tireObject == "Tier4" ? updatedData[index].Tier4 :
      //           tireObject == "Tier5" ? updatedData[index].Tier5 : 0),

      // updatedData[index].UnitPrice,
      updatedData[index].Price,
      updatedData[index].itemquantity,
      updatedData[index].itemdiscount
    );
    updatedData[index] = { ...updatedData[index], Total: Number(total) };

    setStateNew(updatedData);
    updateTotal(updatedData);
    // setDiscountInputValue(value);
  };

  const handleTotalChange = (index, value) => {
    updatedData = [...statenew];
    console.log(updatedData, "handelchange 445");
    let totalvalue = value;
    let itemquantity = updatedData[index].itemquantity;
    let itemdiscount = updatedData[index].itemdiscount;
    if (itemdiscount == undefined || itemdiscount == "") {
      itemdiscount = 0;
    }

    // Calculate the subtotal after applying the discount
    let subtotal = totalvalue / (1 - itemdiscount / 100);

    // Calculate the price per quantity
    let price = subtotal / itemquantity;

    updatedData[index] = { ...updatedData[index], Total: value };
    // updatedData[index] = { ...updatedData[index], UnitPrice: price, Price: price };
    updatedData[index] = { ...updatedData[index], Price: price };

    setStateNew(updatedData);
    updateTotal(updatedData);
  };

  const handleItemsDelete = (index) => {
    const newImageUrls = statenew.filter((_, i) => i !== index);
    setStateNew(newImageUrls);
    updatedData = newImageUrls;
    updateTotal(updatedData);
    const updatedErrors = [...validationErrors];
    updatedErrors.splice(index, 1);
    setValidationErrors(updatedErrors);
  };

  function updateTotal(updatedData) {
    console.log(updatedData, "==> updatedData 445");
    setIsChangedData(true);
    let newTotalQuantity = 0;
    updatedData.forEach((item) => {
      newTotalQuantity += Number(item.itemquantity);
    });
    setTotalQuantity(newTotalQuantity);
    console.log(newTotalQuantity, "==> newTotalQuantity  work 445");

    let newTotal = 0;
    updatedData.forEach((item, index) => {
      let totalPrice = 0;
      // let UnitPrice = item.UnitPrice;
      // if (isNaN(item.UnitPrice)) {
      //   UnitPrice = 0;
      // }

      let UnitPrice = item.Price;
      if (isNaN(item.Price)) {
        UnitPrice = 0;
      }

      let itemdiscount = item.itemdiscount;
      if (isNaN(item.itemdiscount)) {
        itemdiscount = 0;
      }
      // if (!isNaN(item.UnitPrice) && !isNaN(item.itemdiscount)) {
      //   totalPrice = item.UnitPrice * item.itemquantity * (1 - item.itemdiscount / 100);
      // // }
      // if (!isNaN(UnitPrice) && !isNaN(item.itemdiscount)) {
      //   totalPrice = parseFloat(UnitPrice)  * parseFloat(item.itemquantity) * (1 - parseFloat(itemdiscount) / 100);
      // }

      console.log(selectedPriceForSale, "selectedPriceForSale 445");
      // totalPrice = item.UnitPrice * item.itemquantity * (1 - itemdiscount / 100);
      totalPrice =
        parseFloat(UnitPrice) *
        parseFloat(item.itemquantity) *
        (1 - parseFloat(itemdiscount) / 100);

      console.log(totalPrice, "==> totalPrice  work 445");
      newTotal = parseFloat(newTotal) + parseFloat(totalPrice);
    });
    newTotal = parseFloat(newTotal) - Number(commonDiscount);
    console.log(newTotal, "==> newTotal work 445");

    totalRef.current = newTotal;

    let paymentTotal = newTotal - parseFloat(paidAmount);
    if (isNaN(paymentTotal)) {
      paymentTotal = 0;
    }
    console.log(paymentTotal, "<== paymentTotal  work 445");
    setDueAmount(paymentTotal);
  }

  const handleEntireSaleDiscountChange = (event) => {
    const newDiscountValue = Number(event);

    //settingUp data in LS

    if (paramObject.id === undefined) {
      const x = { ...localValues, DiscountChange: newDiscountValue };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }

    setEntireSaleDiscount(
      isNaN(newDiscountValue) || newDiscountValue == 0 || newDiscountValue < 0
        ? ""
        : newDiscountValue
    );

    const updatedDataDiscount = statenew.map((item) => {
      let total = calculateTotal(
        // (selectedPriceForSale === 1 && (item.UnitPrice),
        //   selectedPriceForSale === 3 && (item.RecallPrice),

        //   tireObject == "Tier1" ? item.Tier1 :
        //     tireObject == "Tier2" ? item.Tier2 :
        //       tireObject == "Tier3" ? item.Tier3 :
        //         tireObject == "Tier4" ? item.Tier4 :
        //           tireObject == "Tier5" ? item.Tier5 : 0),
        // updatedData[index].UnitPrice,
        item.Price,
        item.itemquantity,
        newDiscountValue
      );
      return {
        ...item,
        itemdiscount: newDiscountValue,
        Total: Number(total),
      };
    });

    setStateNew(updatedDataDiscount);
    updatedData = updatedDataDiscount;
    updateTotal(updatedData);
  };

  console.log(entireSaleDiscount, "entireSaleDiscount");

  const handleCommonDiscountChange = (event) => {
    const newDiscountValue = Number(event.target.value);

    //setting up the data in LS
    if (paramObject.id === undefined) {
      const x = { ...localValues, EntireSale: newDiscountValue };
      setLocalValues(x);

      localStorage.setItem("saleDraft", JSON.stringify(x));
    }

    setCommonDiscount(newDiscountValue == 0 ? "" : newDiscountValue);

    let newTotal = 0;
    statenew.forEach((item, index) => {
      let totalPrice = 0;
      // let UnitPrice = item.UnitPrice;
      // if (isNaN(item.UnitPrice)) {
      //   UnitPrice = 0;
      // }
      let UnitPrice = item.Price;
      if (isNaN(item.Price)) {
        UnitPrice = 0;
      }
      let itemdiscount = item.itemdiscount;
      if (isNaN(item.itemdiscount)) {
        itemdiscount = 0;
      }
      // if (!isNaN(item.UnitPrice) && !isNaN(item.itemdiscount)) {
      //   totalPrice =
      //     item.UnitPrice * item.itemquantity * (1 - item.itemdiscount / 100);
      // }

      if (!isNaN(item.Price) && !isNaN(item.itemdiscount)) {
        totalPrice =
          item.Price * item.itemquantity * (1 - item.itemdiscount / 100);
      }
      totalPrice = UnitPrice * item.itemquantity * (1 - itemdiscount / 100);
      newTotal = parseFloat(newTotal) + parseFloat(totalPrice);
    });

    const totalAmount = Number(newTotal) - newDiscountValue;
    totalRef.current = totalAmount;

    let paymentTotal = totalAmount - paidAmount;
    if (isNaN(paymentTotal)) {
      paymentTotal = 0;
    }
    setDueAmount(paymentTotal);
  };

  const handleCancelClick = (event) => {
    event.preventDefault();
    setSelectedOption(null);
    setCustomerEmail(null);
    setCustomerAddress(null);
    setSelectedCustomer([]);
    setSalesDeliveryData(null);
    setDeliveryFees(0);
  };

  const handleDeletePayment = (index) => {
    setDeletedPaymentIndex(index);
    let prevDueAmount =
      parseFloat(dueAmount) + parseFloat(payments[index].Paymentamount);
    setDueAmount(prevDueAmount);
    setPayments(payments.filter((payment, i) => i !== index)); // Remove the deleted payment from the payments array
    setDeletedPaymentIndex(-1); // Reset the deletedPaymentIndex state
  };

  const handleChangeCupon = (e) => {
    // console.log(e.target.value);
    setCouponCode(e.target.value);
  };

  const handleDeleteTax = (e, tax, index) => {
    e.preventDefault();
    const filteredData = taxXml.filter(
      (el, currentIndex) => currentIndex !== index
    );

    setTaxXml(filteredData);
    setTaxData(filteredData);

    if (paramObject.id === undefined) {
      const x = { ...localValues, taxArray: filteredData };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
  };
  console.log(taxXml, "filteredData");

  const handlePayment = (method, id, name) => {
    setMethod(method);
    setSelectedPayment({ id, name });
    // console.log(`Selected payment method: ${method}`);
  };

  const handleAmountChange = (event) => {
    // console.log("Event", event.target.value);
    let amount = parseFloat(event.target.value);
    if (Number.isNaN(amount)) {
      amount = 0;
    }
    setAmountToSubtract(amount);
  };

  const handleOptionSelect = (e, label, value) => {
    console.log(e, label, value, "1341");

    // netamount=0
    if (restirctedit == 1 && paramObject.id > 0) {
      setModal(true);
      return;
    }
    setStateNew([]);

    //SettingUp Data in Local Storage
    if (paramObject.id === undefined) {
      const x = { ...localValues, saleDropdown: [value, label] };
      setLocalValues(x);

      localStorage.setItem("saleDraft", JSON.stringify(x));
    }

    setSelectDropDownValue(value);
    let eve = e.target;
    const dataItemId = eve.getAttribute("value");
    const saleType = dataItemId;
    setSaleTypeId(value);
    setSelect(label);
    setIsStoreAccountPayment(label === "Customer Account");
    const selectedOption = salesTypeDropdownOption.find(
      (option) => option.value == saleType
    );

    let o = selectedOption.label;

    setselectedSaleOption(o);

    BindInvoiceDropdown(value);
  };

  // console.log(saleTypeId,"saleTypeId")

  const handleSuspendClick = (e, optiondata) => {
    setSelectDropDownValue(optiondata.value);

    setSaleTypeId(optiondata.value);
    setSelect(optiondata.label);
    setIsStoreAccountPayment(optiondata.label === "Customer Account");
    const selectedOption = salesTypeDropdownOption.find(
      (option) => option.value == optiondata.value
    );

    let o = selectedOption.label;

    setselectedSaleOption(o);
    BindInvoiceDropdown(optiondata.value);
  };

  const handleCancelPopup = (pID) => {
    setStateNew([]);
    updateTotal([]);
    setEntireSaleDiscount([]);
    setSelectedOption(null);
    setPayments([]);
  };

  const handleCheckboxChange = (e, index) => {
    updatedData = [...statenew];
    updatedData[index] = {
      ...updatedData[index],
      IsChecked: e.target.checked == true ? 1 : 0,
    };
    setStateNew(updatedData);
    setCheckboxes(e.target.checked == true ? 1 : 0);
  };

  const _handleFileChange = (e) => {
    setChangeImagename(true);

    if (validation(e.target.name, e?.currentTarget?.files[0])) {
      uploadFile(e?.currentTarget?.files[0], e.target.name);
    }
  };

  const validation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value.name.match(/\.(jpg|jpeg|png|gif|mp4)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const uploadFile = async (file, type) => {
    setBtnLoader({ [type]: true });
    await uploadAWS(file, AWS_IMAGE_FOLDER_SALES, (data) => {
      if (data) {
        if (type === "SelectImage") setImageUrl(data);
        else {
          customFieldSalesValues[type] = {
            CustomFieldLabelID: type,
            CustomFieldValue: data,
          };
          setCustomFileUrl(data);
          setLoading(false);
        }
      }
    });
  };

  const handleChangeComments = (e) => {
    setComment(e.target.value);
    if (paramObject.id === undefined) {
      const x = { ...localValues, finalComment: e.target.value };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
  };

  const handleChangeReason = (e) => {
    if (paramObject.id === undefined) {
      const x = { ...localValues, Reason: e.target.value };
      setLocalValues(x);

      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
    setReason(e.target.value);
  };

  const handleCustomFieldsValues = (event, fieldTypeName, fieldName) => {
    if (fieldTypeName === "Dropdown") {
      customFieldSalesValues[fieldName] = {
        CustomFieldLabelID: fieldName,
        CustomFieldValue: event.value,
      };
    } else if (fieldTypeName === "CheckBox") {
      customFieldSalesValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.checked,
      };
    } else if (fieldName === "E-Mail") {
      customFieldSalesValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else if (fieldName === "Website") {
      customFieldSalesValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else if (fieldName === "PhoneNumber") {
      customFieldSalesValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else if (fieldName === "Date") {
      customFieldSalesValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else {
      customFieldSalesValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    }
  };

  const handleSelectCustomCheckBox = () => {
    setSelectCustomCheckBox(!selectCustomCheckBox);
  };

  function handleChange(event) {
    setFormValues({
      ...formValues,
      [event.target.name]: event.target.value,
    });
  }

  const vaidation = (name, value) => {
    switch (name) {
      case "Receipt":
        if (!value.name.match(/\.(jpg|jpeg|png|pdf)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const uploadFilePDF = async (file, type, index) => {
    setBtnFileLoader({ [type]: true });
    setLoading(true);

    await uploadAWS(file, AWS_IMAGE_FOLDER_SALES, (data) => {
      if (data) {
        if (type === "Receipt") {
          setFileUrl(data);
          setFileName(file.name);
          // console.log(file, "FileUrl")
          if (paramObject.id === undefined) {
            let x = { ...localValues, Attachments: data };
            setLocalValues(x);
            localStorage.setItem("saleDraft", JSON.stringify(x));
          }
          setLoading(false);
        }
      }
    });
  };

  const handleFileChange = (event, index) => {
    setChangeFileName(true);

    if (vaidation(event.target.name, event?.currentTarget?.files[0])) {
      uploadFilePDF(event?.currentTarget?.files[0], event.target.name, index);
    }

    const files = event.target.files;
    console.log(files, "files[i]");
    if (files) {
      let images = [];
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e) => {
          images.push({
            name: files[i].name,
            preview: e.target.result,
          });
        };
        reader.readAsDataURL(files[i]);
      }
    }
  };

  const handleChangeInvoiceDate = (event, fieldName) => {
    setTodayDate(Moment(event.target.value).format("YYYY-MM-DD"));
    setAccountSaleData((item) => ({
      ...item,
      ["InvoiceDate"]: Moment(event.target.value).format("YYYY-MM-DD"),
    }));
    if (paramObject.id === undefined) {
      let x = {
        ...localValues,
        [fieldName]: Moment(event.target.value).format("YYYY-MM-DD"),
      };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
  };

  const handleChangeAccountSalesData = (event, fieldName) => {
    // console.log(event, fieldName, " => coming from input");
    let x;
    console.log(fieldName, event, "newdata1610");
    if (fieldName === "InvoiceStatement") {
      x = { ...localValues, [fieldName]: event };
      let dueDate = new Date(todayDate);
      dueDate.setDate(dueDate.getDate() + event.actualValue);

      setAccountSaleData((prevValues) => ({
        ...prevValues,
        [fieldName]: event,
      }));
    } else if (fieldName === "InvoiceMessage") {
      // console.log(fieldName, event, "new data");
      x = { ...localValues, [fieldName]: event };
      setAccountSaleData((prevValues) => ({
        ...prevValues,
        [fieldName]: event,
      }));
    } else if (fieldName === "DueDate") {
      // console.log(fieldName, event, "new data");
      x = {
        ...localValues,
        [fieldName]: Moment(event.target.value).format("YYYY-MM-DD"),
      };
      setAccountSaleData((prevValues) => ({
        ...prevValues,
        [fieldName]: Moment(event.target.value).format("YYYY-MM-DD"),
      }));
    } else if (fieldName === "TermsID") {
      setAccountSaleData((prevValues) => ({
        ...prevValues,
        [fieldName]: event.value,
      }));
      console.log(accountSaleData, "accountSaleData");
      let dueDate = new Date(todayDate); //  Moment(new Date(accountSaleData.DueDate)).format('YYYY-MM-DD')
      dueDate.setDate(dueDate.getDate() + event.actualValue);

      setAccountSaleData((prevValues) => ({
        ...prevValues,
        ["DueDate"]: Moment(dueDate).format("YYYY-MM-DD"),
      }));
      x = {
        ...localValues,
        [fieldName]: event?.value,
        ["DueDate"]: Moment(dueDate).format("YYYY-MM-DD"),
      };
    } else if (fieldName == "Tags") {
      x = { ...localValues, [fieldName]: event.map((x) => x.value) };
      setSelectedtags(Array.isArray(event) ? event.map((x) => x.value) : []);
    } else if (fieldName === "InvoiceNumber") {
      x = { ...localValues, [fieldName]: event?.target?.value };
      const { name, value } = event.target;

      setAccountSaleData((prevValues) => ({ ...prevValues, [name]: value }));
    } else if (fieldName === "BillingAddress") {
      x = { ...localValues, [fieldName]: event?.target?.value };
      setCustomerAddress(event.target.value);
    } else if (fieldName === "Email") {
      x = { ...localValues, [fieldName]: event?.target?.value };
      setCustomerEmail(event.target.value);
    } else {
      const { name, value } = event.target;
      // console.log(name, value, "new data");

      setAccountSaleData((prevValues) => ({ ...prevValues, [name]: value }));
    }
    if (paramObject.id === undefined) {
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
  };

  console.log(selectedtags, "selected");
  const handleCompleteSale = (salestatus) => {
    const amount = parseFloat(amountToSubtract);
    // console.log("Handle Submit");

    if (salestatus === "complete") {
      if (!amountToSubtract) {
        // display error message
        toast.error("Please enter a valid amount");
        return;
      }

      if (isNaN(amount) || amount <= 0) {
        // display error message
        toast.error("Please enter a valid amount");
        return;
      }

      if (amount > Compairamount) {
        // display error message
        toast.error("The amount entered is greater than the due amount");
        return;
      }
    }

    if (Compairamount > 0 || salestatus === "suspend") {
      let payment = {
        PayId: 0,
        PaymentId: selectedPayment.id,
        Paymentamount: amount,
      };
      let updatedPayments = [...payments];
      if (amount > 0) {
        updatedPayments.push(payment);
      }
      setPayments(updatedPayments);
      originalPass = updatedPayments;
      setDueAmount((prevDueAmount) => prevDueAmount - amount);
      setAmountToSubtract("");
    }
  };

  // console.log("Stateneww", statenew);

  // useEffect(() => {
  //   const updatedStateNew = statenew.map((item) => {
  //     const taxItems = taxXml.filter((tax) => tax.TaxItemID === item.ItemId);
  //     console.log("taxItems::>>", taxItems);
  //     const totalPercent = taxItems.reduce((sum, tax) => sum + ((parseFloat(tax.TaxPercent)*parseFloat(item.UnitPrice))/100), 0);
  //     console.log("taxTotalPercent::>>>", totalPercent);

  //     return {
  //       ...item,
  //       Tax: parseFloat(totalPercent),
  //     };
  //   });

  //   console.log("updatedStateNew", updatedStateNew);
  //   setStateNew(updatedStateNew);
  // }, [taxXml])
  useEffect(() => {
    const updatedStateNew = statenew.map((item) => {
      const taxItems = taxXml.filter((tax) => tax.TaxItemID === item.ItemId);
      // console.log("taxItems::>>", taxItems);
      const totalPercent = taxItems.reduce(
        (sum, tax) =>
          sum + (parseFloat(tax.TaxPercent) * parseFloat(item.UnitPrice)) / 100,
        0
      );
      // console.log("taxTotalPercent::>>>", totalPercent);

      return {
        ...item,
        Tax: parseFloat(totalPercent),
      };
    });

    // Compare the updatedStateNew with the current state to check for changes
    if (!isEqual(updatedStateNew, statenew)) {
      setStateNew(updatedStateNew);
    }
  }, [taxXml]);

  console.log(salesDeliveryData, "salesDeliveryDataJSON");

  const handleSubmit = () => {
    let isValid = true;

    // for (let i = 0; i < statenew.length; i++) {
    //   const item = statenew[i];
    //   const quantity = item.itemquantity;
    //   const currentQuantity = parseFloat(item.ItemCurrentQuantity);

    //   if (quantity > currentQuantity) {
    //     isValid = false;
    //     break; // Stop further iteration if any item fails the condition
    //   }
    // }

    // const updatedStateNew = statenew.map((item) => {
    //   const taxItem = taxXml.find((tax) => tax.TaxItemID === item.ItemId);
    //   console.log("taxItem::>>",taxItem)
    //   if (taxItem) {
    //     const totalPercent = (parseFloat(item.UnitPrice) * parseFloat(taxItem.TaxPercent))/100;
    //     console.log("taxTotalPercenttt::>>>",totalPercent)
    //     // Add the tax key and total percent to the item
    //     return {
    //       ...item,
    //       Tax: parseFloat(totalPercent ? totalPercent : 0),
    //     };
    //   }

    //   return item; // Return the original item if no matching tax item is found
    // });
    // console.log("updatedStateNew", updatedStateNew);

    // const updatedStateNew = statenew.map((item) => {
    //   const taxItems = taxXml.filter((tax) => tax.TaxItemID === item.ItemId);
    //   console.log("taxItems::>>", taxItems);
    //   const totalPercent = taxItems.reduce((sum, tax) => sum + ((parseFloat(tax.TaxPercent)*parseFloat(item.UnitPrice))/100), 0);
    //   console.log("taxTotalPercent::>>>", totalPercent);

    //   return {
    //     ...item,
    //     Tax: parseFloat(totalPercent),
    //   };
    // });

    // console.log("updatedStateNew", updatedStateNew);
    // setStateNew(updatedStateNew);

    if (isValid) {
      // Submit
      // console.log("Submit");
      if (selectedcustomer == "" || selectedcustomer.Id == 0) {
        toastError("Please select a customer");
        return;
      }

      let taxdata = taxXml.filter(function (rowData) {
        return rowData.TaxName != "";
      });

      let customFielddata = customFieldSalesValues.filter(function (rowData) {
        return (
          rowData.CustomFieldLabelID !== null &&
          rowData.CustomFieldValue !== null
        );
      });

      let Itemdata = statenew.filter(function (salesItem) {
        return salesItem.itemsid != "";
      });

      let paymentMethodData = originalPass.filter(function (paymentData) {
        // console.log(paymentData);
        return paymentData.PaymentId != "";
      });

      const Itemobj = {};
      let customValuesData = {};
      let taxValuesData = {};
      let paymentData = {};
      let salesDeliveryDataJSON = {};

      Itemobj.saleitemsXML = Itemdata;
      let itemjsonstring = JSON.stringify(Itemobj);

      customValuesData.customValueXML = customFielddata;
      let customvaluejsonstring = JSON.stringify(customValuesData);

      paymentData.paymentValueXML = paymentMethodData;
      let paymentvaluejsonstring = JSON.stringify(paymentData);

      taxValuesData.itemTaxXML = taxdata;
      let taxjsonstring = JSON.stringify(taxValuesData);

      salesDeliveryDataJSON.salesDeliveryDataXML =
        salesDeliveryData == undefined ? {} : salesDeliveryData;
      // console.log(salesDeliveryData, "salesDeliveryDataJSON")
      let salesDeliveryDataString = JSON.stringify(salesDeliveryDataJSON);

      //salesDeliveryXMLData
      let SalesData = {
        xmlsalesitems: itemjsonstring,
        xmlcustomfieldvalue: customvaluejsonstring,
        xmlitemspayment: paymentvaluejsonstring,
        xmlsalesitemtax: taxjsonstring,
        xmlsalesdeliverydata: salesDeliveryDataString,
        id: Clone > 0 ? 0 : paramObject.id || 0,
        customerid: customerId, // selectedOption.value,
        comment: comment,
        // locationid: selectedLocation == 0 ? Location : selectedLocation,
        locationid: Location,
        saletypeid: saleTypeId,
        suspended: clickedValue,
        storeaccountpayment: isStoreAccountPaymentFlag,
        totalquantitypurchased: totalQuantity,
        totalquantityreceived: 0,
        subtotal:
          paramObject.id === undefined
            ? selectedDropDownValue === 4
              ? sumamount
              : LStotalAmt - commonDiscount
            : paramObject.id !== undefined && selectedDropDownValue === 4
            ? sumamount
            : totalRef.current,
        // total: totalRef.current,
        total: selectedDropDownValue === 4 ? sumamount : netAmount,
        showcommentonreceipt: isChecked === true ? 1 : 0,
        estimate: clickedValue,
        layaway: clickedValue,
        // emailreceipt:
        discountreason: reason,
        discountentiresale: commonDiscount,
        paymentcurrency: paymentCurrency,
        addcoupons: couponCode,
        invoiceno: accountSaleData.InvoiceNumber,
        invoicemessage: accountSaleData?.InvoiceMessage,
        invoicestatement: accountSaleData.InvoiceStatement,
        saletime: Moment(todayDate).format("YYYY-MM-DD"),
        duedate:
          selectedDropDownValue === 4
            ? ""
            : accountSaleData.DueDate == undefined
            ? ""
            : Moment(accountSaleData.DueDate).format("YYYY-MM-DD"),
        termsid:
          accountSaleData.TermsID == undefined ? "" : accountSaleData.TermsID,
        receipt: FileUrl,
        status: 1,
        tagids: selectedtags?.toString(),
        billingaddress: customerAddress,
        emailaddress: customerEmail,
        loginuserid: Id,
      };

      console.log("SalesData", SalesData);
      // return true;
      setLoading(true);

      axios
        .post(`${config.salesconfigBaseUrl}/sales/upsert`, SalesData, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        })
        .then((res) => {
          console.log("check 778899");
          if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
            localStorage.removeItem("Clone");
            toastSuccess(SUCCESS_MESSAGE);
            setLoading(false);
            navigate(`/sales-receipt/${res.data.ResponseID}`);
            // navigate(`/sales-receipt/${res.data.ResponseID}`);
          } else if (res.data.ResponseCode === "ERROR") {
            toastError(ERROR_MESSAGE);
            setLoading(false);
          }
          if (paramObject.id == undefined) {
            localStorage.removeItem("saleDraft");
            localStorage.removeItem("dataAfterDelivery");
            localStorage.removeItem("DeliveryDraft");
            localStorage.removeItem("EditTaxDraft");
          }
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      // Show error
      // console.log("Error: Quantity exceeds current quantity");
      toastError("Quantity exceeds current quantity");
    }
  };

  const handleSuspend = (event) => {
    let taxdata = xmltax.filter(function (rowData) {
      return rowData.TaxName != "";
    });

    let customFielddata = customFieldSalesValues.filter(function (rowData) {
      return (
        rowData.CustomFieldLabelID !== null && rowData.CustomFieldValue !== null
      );
    });

    let Itemdata = statenew.filter(function (salesItem) {
      return salesItem.itemsid != "";
    });

    let p = payments;
    originalPass = p;

    let paymentMethodData = originalPass.filter(function (paymentData) {
      return paymentData.PaymentId != "";
    });

    const Itemobj = {};
    let customValuesData = {};
    let taxValuesData = {};
    let paymentData = {};

    Itemobj.saleitemsXML = Itemdata;
    let itemjsonstring = JSON.stringify(Itemobj);

    customValuesData.customValueXML = customFielddata;
    let customvaluejsonstring = JSON.stringify(customValuesData);

    paymentData.paymentValueXML = paymentMethodData;
    let paymentvaluejsonstring = JSON.stringify(paymentData);

    taxValuesData.itemTaxXML = taxdata;
    let taxjsonstring = JSON.stringify(taxValuesData);

    // Create the form data object
    const formValuesDataToSend = {
      xmlsalesitems: itemjsonstring,
      xmlcustomfieldvalue: customvaluejsonstring,
      xmlitemspayment: paymentvaluejsonstring,
      xmlsalesitemtax: taxjsonstring,
      id: paramObject.id || 0,
      customerid: customerId, // selectedOption.value,
      comment: comment,
      saletypeid: saleTypeId,
      suspended: 1,
      // locationid: selectedLocation, // Location,
      locationid: Location,
      storeaccountpayment: isStoreAccountPaymentFlag,
      totalquantitypurchased: totalQuantity,
      totalquantityreceived: 0,
      subtotal: totalRef.current.toFixed(2),
      // total: totalRef.current.toFixed(2),
      total: selectedDropDownValue === 4 ? paymentAmount : netAmount,
      // total: selectedDropDownValue === 4 ? paymentAmount : netSubAmount,
      showcommentonreceipt: isChecked === true ? 1 : 0,
      estimate: 0,
      layaway: 1,
      // emailreceipt:
      discountreason: reason,
      discountentiresale: commonDiscount,
      paymentcurrency: paymentCurrency,
      addcoupons: couponCode,
      loginuserid: Id,
    };

    // console.log("handle Suspend", formValuesDataToSend);

    // Send the form data using axios
    axios
      .post(`${config.salesconfigBaseUrl}/sales/upsert`, formValuesDataToSend, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log(res);
        // setShowModal(true);
        // console.log("check 778899")
        setLoading(false);
        setStateNew([]);
        updateTotal([]);
        setEntireSaleDiscount([]);
        setSelectedPayment([]);
        setPayments([]);
        setTaxXml([]);
        setSelectedOption(null);
        setIsChecked([]);
        setCouponCode([]);
        setPaymentCurrency([]);
        setReason("");
        setCommonDiscount([]);
        localStorage.removeItem("saleDraft");
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  // Function to handle search input change
  const handleSearchInputChange = (event) => {
    const { value } = event.target;
    setSearchValue(value);

    // Filter the data based on the search value
    const filteredItems = statenew.filter((item) =>
      item.ItemName.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filteredItems);
  };

  const handleForCategorySearch = (event) => {
    if (event && event.value !== null) {
      setSelectedCategoryForSearch(event.value);
    } else {
      setSelectedCategoryForSearch(""); // or null, depending on your needs
    }
  };

  // For Categories
  let categoryDropdownOption = [];
  const categorytypeDropdown = selectedCategory.map((u, i) => {
    categoryDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  console.log(categoryDropdownOption, "categoryDropdownOption");

  const handleItemsDetailsData = (itemDetails) => {
    // console.log("itemDetails", itemDetails.ItemId);
    // setItemsDetailsData(itemDetails.ItemId);
    setItemsDetailsData(itemDetails);
  };

  // location dropdown Binding.
  let locationDropdownOption = [];
  const locationDropdown = locationdropdown.map((u, i) => {
    locationDropdownOption[i] = { label: u.Name, value: u.Id };
  });

  console.log(locationDropdownOption, "locationDropdownOption 121212121");
  // handle Change for the location.

  const handelpaymentAmount = (e) => {
    setPaymentAmount(e.target.value);
    if (paramObject.id === undefined) {
      const x = { ...localValues, paymentAmount: e.target.value };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
  };

  const handleLocationChange = (e) => {
    if (paramObject.id === undefined) {
      const x = { ...localValues, locationWarehouseDropdown: e.value };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
    console.log("selectedOption ==>", e.value);
    setSelectedLocation(e.value);
  };
  const [drill, setDrill] = useState(false);
  const handleDrillDown = (e) => {
    // console.log("drill", drill);
    drill ? setDrill(false) : setDrill(true);
  };
  // console.log("salesTypeDropdownOption::>>",salesTypeDropdownOption);

  // function calculateItemTax(total, taxPercent, stateLength) {
  //   return (total * taxPercent) / 100 / stateLength;
  // }
  // const [uniqueTaxItemCount, setUniqueTaxItemCount] = useState([]);
  // function calculateOtherTax(total, taxPercent, stateLength, taxXml) {
  //   return (
  //     (total * parseInt(taxPercent)) / 100 / (1 + parseInt(uniqueTaxItemCount))
  //   );
  // }
  // function calculateDeliveryTax(total, taxPercent) {
  //   return (total * parseInt(taxPercent)) / 100;
  // }

  // useEffect(() => {
  //   const uniqueTaxItemIds = [
  //     ...new Set(
  //       taxXml
  //         ?.filter((item) => item?.TaxItemID !== null && item?.TaxItemID !== "")
  //         .map((item) => item.TaxItemID)
  //     ),
  //   ];
  //   const uniqueTaxItemCount = uniqueTaxItemIds.length;
  //   console.log("uniqueTaxItemCount", uniqueTaxItemCount);
  //   console.log("uniqueTaxItemCount", uniqueTaxItemIds);
  //   setUniqueTaxItemCount(uniqueTaxItemCount);
  //   calculateItemTax();
  //   calculateOtherTax();
  //   calculateDeliveryTax();
  // }, [statenew, taxXml, totalRef]);

  // // taxXml?.forEach((tax) => {
  // //   totalTaxAmount += (totalRef.current * tax.TaxPercent) / 100;
  // // });
  // taxXml?.forEach((tax) => {
  //   if (tax.type === "globalTax") {
  //     totalTaxAmount += calculateOtherTax(
  //       totalRef.current,
  //       tax.TaxPercent,
  //       statenew.length,
  //       taxXml
  //     );
  //   } else if (tax.type === "itemTax") {
  //     totalTaxAmount += calculateItemTax(
  //       totalRef.current,
  //       tax.TaxPercent,
  //       statenew.length
  //     );
  //   } else if (tax.type === "deliveryTax") {
  //     totalTaxAmount += calculateDeliveryTax(totalRef.current, tax.TaxPercent);
  //   }
  // });
  // console.log("totalRef", totalRef);
  // console.log("totalTaxAmount::>>", totalTaxAmount);
  // let netAmount = (
  //   parseFloat(totalRef.current) +
  //   parseFloat(totalTaxAmount) +
  //   parseFloat(isNaN(deliveryFees) ? 0 : deliveryFees)
  // ).toFixed(2);
  // console.log("netAmount::>>", netAmount);
  // console.log("netAmount", netAmountValue);
  // netAmountValueRef.current = netAmount;
  // setNetAmountValue(netAmount);
  let Compairamount = (
    parseFloat(dueAmount) + parseFloat(totalTaxAmount)
  ).toFixed(2);
  // console.log("totalTaxAmount", totalTaxAmount);

  const DefaultSellingPrice = [
    // {
    //   label: "Default Selling Price",
    //   value: 1
    // },
    {
      label: "Default Selling Price",
      value: 1,
    },
    {
      label: "Tier Price",
      value: 2,
    },
    {
      label: "Recall Price",
      value: 3,
    },
  ];

  const handleChangePrice = (event, index) => {
    // console.log(event?.label, "handleChangePrice");
    // console.log(event?.value, "handleChangePrice");

    if (event?.value !== null && event?.value !== undefined) {
      setSelectedPriceForSale(event.value);

      if (event?.value !== 2) {
        setTireObject(null);
      }
      if (event?.value === 2 || event?.value === 3) {
        handleEntireSaleDiscountChange(0);
      }
    } else {
      setSelectedPriceForSale(1); // or null, depending on your needs
    }

    const selectedPrice = event?.value;
    console.log("selectedPriceForSale ==>", selectedPrice);
    // updatedData = [...statenew];

    // let newUpdatedData = statenew.map((e, index) => {
    //   return {
    //     ...e,
    //     Price: 0
    //   }
    // });

    let newUpdatedData = statenew.map((e, index) => {
      return {
        ...e,
        Price:
          selectedPrice == undefined
            ? statenew[index].UnitPrice
            : selectedPrice === 1
            ? statenew[index].UnitPrice
            : selectedPrice === 3
            ? statenew[index].RecallPrice
            : tireObject == "Tier1"
            ? statenew[index].Tier1
            : tireObject == "Tier2"
            ? statenew[index].Tier2
            : tireObject == "Tier3"
            ? statenew[index].Tier3
            : tireObject == "Tier4"
            ? statenew[index].Tier4
            : tireObject == "Tier5"
            ? statenew[index].Tier5
            : 0,
        Total: calculateTotal(
          selectedPrice == undefined
            ? statenew[index].UnitPrice
            : selectedPrice === 1
            ? statenew[index].UnitPrice
            : selectedPrice === 3
            ? statenew[index].RecallPrice
            : tireObject == "Tier1"
            ? statenew[index].Tier1
            : tireObject == "Tier2"
            ? statenew[index].Tier2
            : tireObject == "Tier3"
            ? statenew[index].Tier3
            : tireObject == "Tier4"
            ? statenew[index].Tier4
            : tireObject == "Tier5"
            ? statenew[index].Tier5
            : 0,
          e.itemquantity,
          e.itemdiscount
        ),
      };
    });

    console.log("newUpdatedData ==>", newUpdatedData);
    updatedData = newUpdatedData;
    setStateNew(newUpdatedData);
    updateTotal(newUpdatedData);
  };

  console.log(statenew, "statenew2250");

  useEffect(() => {
    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/Roletierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        // console.log(response.data?.ResponseData, "response of tire list")
        setDefaultSellingTierPriceList(response.data?.ResponseData);
      })
      .catch((error) => {
        console.log(error.message);
      });
  }, [selectedPriceForSale]);

  const handleRemoveLocalData = () => {
    navigate("/sales");
    localStorage.removeItem("saleDraft");
    localStorage.removeItem("EditTaxDraft");
    localStorage.removeItem("DeliveryDraft");
    localStorage.removeItem("dataAfterDelivery");
  };

  const handleChangeTierPrice = (event, index) => {
    console.log(event?.label, event?.value, event?.id, "handleChangeTierPrice");
    setTireObject(event?.value);
    // console.log(event, "handleChangeTierPrice");

    // if (event && event?.value !== null) {
    //   setSelectedTirePriceForSale(event.value);
    // } else {
    //   setSelectedTirePriceForSale(""); // or null, depending on your needs
    // }

    const selectedPrice = event?.value;
    console.log("selectedPriceForSale ==>", selectedPrice);
    // updatedData = [...statenew];
    const newUpdatedData = statenew.map((e, index) => {
      return {
        ...e,
        Price:
          selectedPriceForSale === 1
            ? statenew[index].UnitPrice
            : selectedPriceForSale === 3
            ? statenew[index].RecallPrice
            : selectedPrice == "Tier1"
            ? statenew[index].Tier1
            : selectedPrice == "Tier2"
            ? statenew[index].Tier2
            : selectedPrice == "Tier3"
            ? statenew[index].Tier3
            : selectedPrice == "Tier4"
            ? statenew[index].Tier4
            : selectedPrice == "Tier5"
            ? statenew[index].Tier5
            : 0,
        Total: calculateTotal(
          selectedPriceForSale === 1
            ? statenew[index].UnitPrice
            : selectedPriceForSale === 3
            ? statenew[index].RecallPrice
            : selectedPrice == "Tier1"
            ? statenew[index].Tier1
            : selectedPrice == "Tier2"
            ? statenew[index].Tier2
            : selectedPrice == "Tier3"
            ? statenew[index].Tier3
            : selectedPrice == "Tier4"
            ? statenew[index].Tier4
            : selectedPrice == "Tier5"
            ? statenew[index].Tier5
            : 0,
          e.itemquantity,
          e.itemdiscount
        ),
      };
    });

    console.log("newUpdatedData ==>", newUpdatedData);
    updatedData = newUpdatedData;
    setStateNew(newUpdatedData);

    updateTotal(newUpdatedData);
  };

  console.log(selectedPriceForSale, "selectedPriceForSale  nowWork");
  console.log(tireObject, "TireObject nowWork");

  console.log(statenew, "statenew nowWork");

  // useEffect(() => {
  //   // Perform any logic or actions you want to execute when `selectedPriceForSale` changes
  //   // For example, you can trigger the change event here
  //   const inputElement = document.getElementsByClassName("pricecontrol"); //document.getElementById('your-input-id');
  //   const event = new Event('change');
  //   inputElement.dispatchEvent(event);
  // }, [selectedPriceForSale]);

  useEffect(() => {
    if (paramObject.id === undefined) {
      //It's for the deliveryFees Draft
      const deliveryData = localStorage.getItem("DeliveryDraft") || "";
      if (deliveryData && paramObject.id === undefined) {
        const parsedDeliveryData = JSON.parse(deliveryData);
        setLocalValues(parsedDeliveryData);
        setDeliveryFees(parsedDeliveryData?.deliveryFees);
        console.log(parsedDeliveryData, "parsedDeliveryData");
        setSalesDeliveryData({
          Id: 0,
          Saleid: 0,
          EmployeId: parsedDeliveryData?.deliveryEmployee,
          Status: parsedDeliveryData?.status,
          CategoryId: parsedDeliveryData?.category,
          Duration: parsedDeliveryData?.duration,
          LocationId: parsedDeliveryData?.location,
          FirstName: parsedDeliveryData?.salesDeliveryDetails?.FirstName,
          LastName: parsedDeliveryData?.salesDeliveryDetails?.LastName,
          Email: parsedDeliveryData?.salesDeliveryDetails?.Email,
          PhoneNumber: parsedDeliveryData?.salesDeliveryDetails?.PhoneNumber,
          ContactPrefrence:
            parsedDeliveryData?.salesDeliveryDetails?.selectedOption,
          Address1: parsedDeliveryData?.salesDeliveryDetails?.Address1,
          Address2: parsedDeliveryData?.salesDeliveryDetails?.Address2,
          City: parsedDeliveryData?.salesDeliveryDetails?.City,
          State: parsedDeliveryData?.salesDeliveryDetails?.StateProvince,
          Zip: parsedDeliveryData?.salesDeliveryDetails?.Zip,
          Country: parsedDeliveryData?.salesDeliveryDetails?.Country,
          TranckingNumber: parsedDeliveryData?.trackingNumber,
          Commesetitemnts: parsedDeliveryData?.deliveryComment,
          EstimatedShippingDate: parsedDeliveryData?.dateTime,
          EstimatedDeliveryDate: parsedDeliveryData?.deliveryDateTime,
          DeliveryFees: parsedDeliveryData?.deliveryFees,
          Shippingzoneid:
            parsedDeliveryData?.Shippingzoneid === undefined
              ? 0
              : parsedDeliveryData?.Shippingzoneid,
          Taxclassid:
            parsedDeliveryData?.taxDropdownValue === undefined
              ? 0
              : parsedDeliveryData?.taxDropdownValue,
          Loginuserid: loginUserId,
          Ispickup:
            parsedDeliveryData?.Ispickup === undefined
              ? 0
              : parsedDeliveryData?.Ispickup,
        });
      }
      //All Draft data for the manage sales
      const savedData = localStorage.getItem("saleDraft") || "";
      if (savedData && paramObject.id == undefined) {
        const parsedData = JSON.parse(savedData);
        setLocalValues(parsedData);
        setSelectedLocation(parsedData.locationWarehouseDropdown);
        if (parsedData?.saleDropdown != undefined) {
          setSelectDropDownValue(parsedData?.saleDropdown[0]);
          setselectedSaleOption(parsedData?.saleDropdown[1]);
        }
        setSelectedtags(parsedData.Tags);
        // setAccountSaleData(parsedData.TermsID);
        setcustomerId(parsedData?.dropdownCustomers?.value);
        setSelectedOption(parsedData?.dropdownCustomers);
        setStateNew(parsedData?.inputDropdown);
        setReason(parsedData?.Reason);
        setEntireSaleDiscount(parsedData?.DiscountChange);
        setCommonDiscount(
          parsedData?.EntireSale == undefined ? 0 : parsedData?.EntireSale
        );
        handleCustomerDropdownChange(parsedData?.dropdownCustomers?.value);
        setAccountSaleData({
          ...accountSaleData,
          TermsID: parsedData?.TermsID,
          InvoiceMessage: parsedData?.InvoiceMessage,
          InvoiceStatement: parsedData?.InvoiceStatement,
          DueDate: parsedData?.DueDate,
          InvoiceDate: parsedData?.InvoiceDate,
          Attachment: parsedData?.Attachments,
        });
        setComment(parsedData?.finalComment);
        setPaymentAmount(parsedData?.paymentAmount);
        const draftTaxData = localStorage.getItem("EditTaxDraft") || "";
        console.log(draftTaxData, "draftTaxData");
        console.log(parsedData?.taxArray, "draftTaxData");
        if (parsedData?.taxArray && paramObject.id == undefined) {
          setTaxData(parsedData?.taxArray);
          setGlobalTaxData(parsedData?.taxArray);
        }
        // if (parsedData?.taxArray?.some((item) => item.type === "globalTax")) {
        // }
      }
    }
  }, []);

  console.log(commonDiscount, "commonDiscount");

  const updateLocalValues = (statenew) => {
    if (paramObject.id === undefined) {
      const localValue1 = JSON.parse(localStorage.getItem("saleDraft")) || "";
      const x = { ...localValue1, inputDropdown: statenew };
      setLocalValues(x);
      localStorage.setItem("saleDraft", JSON.stringify(x));
    }
  };
  console.log(paramObject.id, "2400");

  useEffect(() => {
    if (paramObject.id === undefined) {
      updateLocalValues(statenew);
    }
  }, [statenew]);

  const sumamount = statenew?.reduce((acc, curr) => {
    acc += Number(curr.Total);
    return acc;
  }, 0);

  const handelpayment = (e, index) => {
    console.log(e, index, "indexss==>");
    const updateddata = [...statenew];
    updateddata[index] = { ...updateddata[index], Total: e?.target.value };
    setStateNew(updateddata);
  };

  // console.log(statenew,"wert")

  const handleRowDelete = (index) => {
    const updateddata = [...statenew];
    updateddata.splice(index, 1);
    setStateNew(updateddata);
  };

  const handeldescription = (e, index) => {
    const updateddata = [...statenew];
    updateddata[index] = {
      ...updateddata[index],
      Description: e?.target.value,
    };
    setStateNew(updateddata);
  };

  console.log(sumamount, "sumamount");

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h5 className="page-title">Sales</h5>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/sales">Sales List</Link>
                </li>
                <li className="breadcrumb-item active">Manage Sales</li>
              </ul>
            </div>
            {/* {salesTypeDropdownOption.map((option, index) => (
              <div className="col-md-2">
                <button
                  type="button"
                  // className="btn btn-outline-success mt-3 w-100"
                  className={`btn ${option.label === selectedSaleOption
                    ? "btn btn-primary"
                    : "btn-outline-primary"
                    } mt-3 w-100`}
                  value={option.value}
                  onClick={(e) => handleSuspendClick(e, option)}
                >
                  {option.label}
                </button>
              </div>
            ))} */}
          </div>
        </div>

        <div className="row p-3">
          <div class="d-flex flex-column col-md-8">
            <div class="">
              {/* Accounting Sales new modification */}
              <div className="card col-md-12">
                <div className="card-body" style={{ padding: "5px" }}>
                  <div className="d-flex flex-row justify-content-between">
                    <div className="p-2 col-md-3">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-success dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        value={saleTypeId}
                      >
                        <i className="fas fa-shopping-cart me-1"></i>
                        {selectedSaleOption}
                      </button>

                      <ul className="dropdown-menu">
                        {salesTypeDropdownOption.map((option, index) => (
                          <li key={index}>
                            <a
                              value={option.value}
                              className="dropdown-item"
                              onClick={
                                (event) =>
                                  handleOptionSelect(
                                    event,
                                    option.label,
                                    option.value
                                  )
                                // handleOptionSelect(event)
                              }
                            >
                              {option.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>{" "}
                    {restirctedit == 1 && (
                      <div
                        style={{
                          border: "1px solid red",
                          padding: "5px 10px",
                          color: "red",
                          borderRadius: "5px",
                        }}
                      >
                        Payment transaction has been intiated, so you can't
                        update the record.
                      </div>
                    )}
                    {/* {selectedDropDownValue == 4 || (
                      <div className="p-2 col-md-6 ">
                        <Select
                          placeholder="WareHouse"
                          className="w-100"
                          options={locationDropdownOption}
                          styles={selectStyles}
                          onChange={(e) => handleLocationChange(e)}
                          value={locationDropdownOption.find(
                            (option) => option?.value == selectedLocation
                          )}
                        />
                      </div>
                    )} */}
                    {(selectedDropDownValue === 1 ||
                      selectedDropDownValue === 2 ||
                      selectedDropDownValue === 3) && (
                      <div
                        className="p-2 col-md-4"
                        style={{
                          marginTop: "6px",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "16px",
                        }}
                      >
                        {/* <div className="p-2 col-md-5"> */}
                        <span>
                          {selectedDropDownValue === 1
                            ? "Invoice Number:"
                            : selectedDropDownValue === 2
                            ? "Return Number:"
                            : selectedDropDownValue === 3
                            ? "Estimated Number:"
                            : ""}{" "}
                        </span>
                        {/* <br></br> */}
                        {/* </div> */}
                        <span
                        // style={{
                        //   // "font-size": "20px",
                        //   // "font-weight": "bold",
                        //   // marginTop:"20px"
                        // }}
                        >
                          {accountSaleData?.InvoiceNumber}
                        </span>
                      </div>
                    )}
                  </div>

                  {/* {selectedDropDownValue === 5 && (
                    <>
                      <div className="d-flex flex-row">
                        <div className="p-2 col-md-12"></div>
                      </div>
                      <div className="d-flex flex-row">
                        <div className="p-2 col-md-4">
                          <span>Sales Receipt Number: </span>
                          <input
                            type="number"
                            id="InvoiceNumber"
                            name="InvoiceNumber"
                            placeholder="Invoice Number"
                            className="form-control"
                            min="0"
                            onChange={(event) =>
                              handleChangeAccountSalesData(
                                event,
                                "InvoiceNumber"
                              )
                            }
                            value={accountSaleData?.InvoiceNumber}
                          />
                        </div>
                        <div className="p-2 col-md-4">
                          Sales Receipt Date:
                          <input
                            type="date"
                            className="form-control"
                            id="SaleReceiptDate"
                            name="SaleReceiptDate"
                            value={todayDate}
                          />
                        </div>
                        <div className="p-2 col-md-4">
                          Attachments:
                          <input
                            type="file"
                            className="form-control"
                            id="Receipt"
                            name="Receipt"
                            onChange={handleFileChange}
                          />
                          {accountSaleData?.Attachment == undefined ? (
                            ""
                          ) : (
                            <Link
                              to={accountSaleData?.Attachment}
                              target="_blank"
                            >
                              Attachment Link
                            </Link>
                          )}
                        </div>
                      </div>
                      <div className="d-flex flex-row">
                        <div className="p-2 col-md-6">
                          Tags:
                          <Select
                            onChange={(event) => {
                              handleChangeAccountSalesData(event, "Tags");
                            }}
                            value={tagOptions.filter((obj) =>
                              selectedtags.includes(obj.value)
                            )}
                            options={tagOptions}
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={true}
                            hideSelectedOptions={true}
                            isClearable={true}
                            isMulti={true}
                            styles={selectStyles}
                            id="Tags"
                            name="Tags"
                          />
                        </div>
                      </div>
                      <div className="d-flex flex-row mb-2">
                        <div className="p-2 col-md-4">
                          Message displayed on sales receipt:
                          <textarea
                            id="InvoiceMessage"
                            name="InvoiceMessage"
                            placeholder="Message displayed on sales receipt"
                            className="form-control h-100"
                            onChange={(event) =>
                              handleChangeAccountSalesData(
                                event,
                                "InvoiceMessage"
                              )
                            }
                            defaultValue={accountSaleData?.InvoiceMessage}
                          ></textarea>
                        </div>
                        <div className="p-2 col-md-4">
                          Message displayed on statement
                          <textarea
                            id="InvoiceStatement"
                            name="InvoiceStatement"
                            placeholder="Message displayed on statement"
                            className="form-control h-100"
                            onChange={(event) =>
                              handleChangeAccountSalesData(
                                event,
                                "InvoiceStatement"
                              )
                            }
                            defaultValue={accountSaleData?.InvoiceStatement}
                          ></textarea>
                        </div>
                        <div className="p-2 col-md-4">
                          Billing Address:
                          <textarea
                            id="BillingAddress"
                            name="BillingAddress"
                            placeholder="Billing Address"
                            className="form-control h-100"
                            onChange={(event) =>
                              handleChangeAccountSalesData(
                                event,
                                "BillingAddress"
                              )
                            }
                            defaultValue={
                              customerAddress == undefined ||
                                customerAddress == ""
                                ? ""
                                : customerAddress
                            }
                          ></textarea>
                        </div>
                      </div>
                    </>
                  )} */}

                  {(selectedDropDownValue === 1 ||
                    selectedDropDownValue === 2 ||
                    selectedDropDownValue === 4 ||
                    selectedDropDownValue === 3) && (
                    <>
                      <div className="d-flex flex-row">
                        {selectedDropDownValue === 1 && (
                          <div className="p-2 col-md-3">
                            Terms:
                            <Select
                              onChange={(event) => {
                                handleChangeAccountSalesData(event, "TermsID");
                              }}
                              value={termOptions.find(
                                (option) =>
                                  option?.value == accountSaleData?.TermsID
                              )}
                              options={termOptions}
                              backspaceRemovesValue={false}
                              // controlShouldRenderValue={true}
                              // isClearable={true}
                              styles={selectStyles}
                              id="TermsID"
                              name="TermsID"
                              className="custom-search-select"
                              // hideSelectedOptions={true}
                            />
                          </div>
                        )}

                        <div className="p-2 col-md-3">
                          <span>
                            {selectedDropDownValue === 1
                              ? "Invoice Date:"
                              : selectedDropDownValue === 2
                              ? "Return Date:"
                              : selectedDropDownValue === 4
                              ? "Payment Date:"
                              : selectedDropDownValue === 3
                              ? "Estimate Date:"
                              : ""}{" "}
                          </span>
                          <input
                            type="date"
                            className="form-control form-control-sm"
                            id="InvoiceDate"
                            name="InvoiceDate"
                            // value={todayDate}
                            value={
                              accountSaleData?.InvoiceDate == ""
                                ? todayDate
                                : accountSaleData?.InvoiceDate
                            }
                            onChange={(event) =>
                              handleChangeInvoiceDate(event, "InvoiceDate")
                            }
                          />
                        </div>

                        {(selectedDropDownValue === 1 ||
                          selectedDropDownValue === 3) && (
                          <>
                            <div className="p-2 col-md-3">
                              <span>
                                {selectedDropDownValue === 1
                                  ? "Due Date:"
                                  : selectedDropDownValue === 4
                                  ? "Payment Date:"
                                  : selectedDropDownValue === 3
                                  ? "Expiration Date:"
                                  : ""}{" "}
                              </span>
                              <input
                                type="date"
                                className="form-control form-control-sm"
                                id="DueDate"
                                name="DueDate"
                                onChange={(event) =>
                                  handleChangeAccountSalesData(event, "DueDate")
                                }
                                value={Moment(
                                  accountSaleData?.DueDate == ""
                                    ? Moment(new Date()).format("YYYY-MM-DD")
                                    : accountSaleData?.DueDate
                                ).format("YYYY-MM-DD")}
                              />
                            </div>
                          </>
                        )}

                        {/* <div className="p-2 col-md-6">
                            Attachments:
                            <input
                              type="file"
                              className="form-control form-control-sm"
                              id="Receipt"
                              name="Receipt"
                              onChange={handleFileChange}
                            />
                            {accountSaleData?.Attachment == undefined ||
                              accountSaleData?.Attachment == "" ? (
                              ""
                            ) : (
                              <Link
                                to={accountSaleData?.Attachment}
                                target="_blank"
                              >
                                Attachment Link
                              </Link>
                            )}
                          </div> */}
                      </div>

                      <div className="d-flex flex-row">
                        <div className="p-2 col-md-7">
                          Tags:
                          <Select
                            onChange={(event) => {
                              handleChangeAccountSalesData(event, "Tags");
                            }}
                            // value={outputMatchedOptions}
                            value={tagOptions?.filter((obj) =>
                              selectedtags?.includes(obj.value)
                            )}
                            options={tagOptions}
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={true}
                            hideSelectedOptions={true}
                            isClearable={true}
                            isMulti={true}
                            styles={selectStyles}
                            id="Tags"
                            name="Tags"
                            className="custom-search-select"
                          />
                        </div>
                        <div className="p-2 col-md-4">
                          Attachments:
                          <input
                            type="file"
                            className="form-control form-control-sm"
                            id="Receipt"
                            name="Receipt"
                            onChange={handleFileChange}
                          />
                          {accountSaleData?.Attachment == undefined ||
                          accountSaleData?.Attachment == "" ? (
                            ""
                          ) : (
                            <Link
                              to={accountSaleData?.Attachment}
                              target="_blank"
                            >
                              Attachment Link
                            </Link>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div class="">
              <div className="card col-md-12">
                <div className="card-body">
                  {/* {selectedDropDownValue != 4 && ( */}
                  <>
                    {selectedDropDownValue != 4 && toggleItemsFilterSection && (
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <div style={{ display: "flex" }}>
                          {/* Default Selling Price */}
                          <div className="p-2 col-md-4">
                            Price Rule
                            <Select
                              options={DefaultSellingPrice}
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              isClearable={true}
                              styles={selectStyles}
                              onChange={(e, index) =>
                                handleChangePrice(e, index)
                              }
                            />
                          </div>
                          {selectedPriceForSale == 2 && (
                            <>
                              <div className="p-2 col-md-4">
                                Role Tier
                                <Select
                                  options={defaultSellingTierPriceList.map(
                                    (tire) => ({
                                      label: tire.Name,
                                      value: tire.Code,
                                      id: tire.ID,
                                    })
                                  )}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  hideSelectedOptions={true}
                                  isClearable={true}
                                  styles={selectStyles}
                                  onChange={(e, index) =>
                                    handleChangeTierPrice(e, index)
                                  }
                                />
                              </div>
                            </>
                          )}

                          {/* Search Invoice Below */}
                          <div className="p-2 col-md-4">
                            Search Items Below
                            <input
                              type="text"
                              id="SearchInvoice"
                              name="SearchInvoice"
                              placeholder="Search Items"
                              className="form-control"
                              value={searchValue}
                              onChange={handleSearchInputChange}
                            ></input>
                          </div>
                        </div>
                        {/* Filter Category */}
                        <div className="p-2 col-md-8">
                          Filter Category
                          <Select
                            onChange={(event) => {
                              handleForCategorySearch(event);
                            }}
                            options={categoryDropdownOption}
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={true}
                            hideSelectedOptions={true}
                            isClearable={true}
                            styles={selectStyles}
                          />
                        </div>
                      </div>
                    )}

                    {selectedDropDownValue == 4 && toggleItemsFilterSection && (
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <div style={{ display: "flex" }}>
                          {/* Default Selling Price */}

                          {/* Search Invoice Below */}
                          <div className="p-2 col-md-4">
                            Search Items Below
                            <input
                              type="text"
                              id="SearchInvoice"
                              name="SearchInvoice"
                              placeholder="Search Items"
                              className="form-control"
                              value={searchValue}
                              onChange={handleSearchInputChange}
                            ></input>
                          </div>
                        </div>
                        {/* Filter Category */}
                      </div>
                    )}

                    <div className="d-flex flex-row mt-2">
                      <div className="p-2 col-md-7">
                        <React.Fragment>
                          {selectedOption?.value ? (
                            <SearchableDropdown
                              customerID={customerId}
                              callback={callback}
                              options={options}
                              value={selectedDropDownValue}
                              // readonly={isReadOnly}
                              callbackaccount={callbackaccount}
                            />
                          ) : (
                            <SearchableDropdown
                              customerID={customerId}
                              callback={callback}
                              options={options}
                              readonly={
                                //  isReadOnly
                                isReadOnly
                              }
                              value={selectedDropDownValue}
                              callbackaccount={callbackaccount}
                            />
                          )}
                        </React.Fragment>
                      </div>

                      {(selectedDropDownValue === 1 ||
                        selectedDropDownValue === 2 ||
                        // selectedDropDownValue === 4 ||
                        selectedDropDownValue === 3) && (
                        <div className="p-2 col-md-3">
                          <Link
                            type="button"
                            className="btn btn-outline-primary w-100"
                            data-bs-target="#exampleModal"
                            data-bs-toggle="modal"
                            onClick={() => setRunApi(true)}
                          >
                            <i className="fa fa-filter me-1"></i> Item Grid
                          </Link>
                        </div>
                      )}

                      <div className="p-2 col-md-2">
                        <Link
                          type="button"
                          className="btn btn-outline-dark w-100"
                          onClick={() =>
                            setToggleItemsFilterSection(
                              !toggleItemsFilterSection
                            )
                          }
                        >
                          {!toggleItemsFilterSection ? (
                            <>
                              <i className="fa fa-arrow-up me-1"></i>
                              Filter{" "}
                            </>
                          ) : (
                            <>
                              <i className="fa fa-arrow-down me-1"></i>
                              Filter{" "}
                            </>
                          )}
                        </Link>
                      </div>
                    </div>

                    {selectedDropDownValue !== 4 && (
                      <div className="d-flex flex-row mt-2">
                        <div className="col-md-12 ">
                          <div className="form-check form-switch mb-3 pull-right">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="toggle-button"
                              checked={isContentVisible}
                              onClick={() =>
                                setIsContentVisible(!isContentVisible)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="toggle-button"
                            >
                              {isContentVisible
                                ? "Disable Pick List"
                                : "Enable Pick List"}
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                  {/* )}  */}

                  <div className="row mt-3">
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <table className="table table-striped custom-table">
                          <thead>
                            <tr>
                              {selectedDropDownValue !== 4 && (
                                <>
                                  {drill ? (
                                    <th
                                      style={{ width: "50px" }}
                                      onClick={(e) => handleDrillDown(e)}
                                    >
                                      <i class="fa fa-minus"></i> No.
                                    </th>
                                  ) : (
                                    <th
                                      style={{ width: "50px" }}
                                      onClick={(e) => handleDrillDown(e)}
                                    >
                                      <i class="fa fa-plus"></i> No.
                                    </th>
                                  )}
                                </>
                              )}

                              {selectedDropDownValue === 4 && (
                                <>
                                  <th>No.</th>
                                  <th>Category</th>
                                  <th>Description</th>
                                  <th>Amount</th>
                                  <th>Delete</th>
                                  <th>
                                    <input
                                      className="form-check-input form-control "
                                      type="checkbox"
                                      name="CheckBox"
                                      id="CheckBox"
                                      onChange={(e) => {
                                        const checkboxes =
                                          document.querySelectorAll(
                                            'tbody input[type="checkbox"]'
                                          );
                                        checkboxes.forEach((checkbox) => {
                                          checkbox.checked = e.target.checked;
                                        });
                                      }}
                                    />
                                  </th>
                                </>
                              )}

                              {selectedDropDownValue != 4 && (
                                <>
                                  <th style={{ width: "150px" }}>Price</th>
                                  <th style={{ width: "120px" }}>Qty</th>
                                  {(selectedPriceForSale == 1 ||
                                    selectedPriceForSale == "" ||
                                    selectedPriceForSale == null) && (
                                    <th style={{ width: "120px" }}>Disc.(%)</th>
                                  )}
                                  <th style={{ width: "120px" }}>Total</th>
                                  <th
                                    style={{ width: "50px" }}
                                    className="text-center"
                                  ></th>
                                  <th
                                    style={{ width: "50px" }}
                                    className="text-center"
                                  >
                                    {isContentVisible && (
                                      <input
                                        className="form-check-input form-control"
                                        type="checkbox"
                                        name="CheckBox"
                                        id="CheckBox"
                                        onChange={(e) => {
                                          const checkboxes =
                                            document.querySelectorAll(
                                              'tbody input[type="checkbox"]'
                                            );
                                          checkboxes.forEach((checkbox) => {
                                            checkbox.checked = e.target.checked;
                                          });
                                        }}
                                      />
                                    )}
                                  </th>
                                </>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {selectedDropDownValue === 4 &&
                              statenew?.map((item, index) => {
                                return (
                                  <>
                                    <tr>
                                      <td>{index + 1}</td>
                                      <td>{item.ItemName}</td>
                                      <td>
                                        <input
                                          id="Description"
                                          name="Description"
                                          type="text"
                                          className="form-control "
                                          value={item?.Description}
                                          onChange={(e) =>
                                            handeldescription(e, index)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          id="paymentamount"
                                          name="paymentamount"
                                          type="number"
                                          className="form-control "
                                          value={item?.Total}
                                          onChange={(e) =>
                                            handelpayment(e, index)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <Link
                                          className="confirm-text"
                                          to="#"
                                          title="Delete"
                                          style={{ fontSize: "12px" }}
                                          onClick={() => handleRowDelete(index)}
                                        >
                                          <i
                                            className="fa fa-trash text-red fa-2x"
                                            data-bs-toggle="tooltip"
                                            title="Delete"
                                          ></i>
                                        </Link>
                                      </td>

                                      <td>
                                        <input
                                          className="form-check-input form-control"
                                          type="checkbox"
                                          name={`CheckBox${index}`}
                                          id={`CheckBox${index}`}
                                          defaultChecked={item.Ischecked}

                                          // onChange={(e) =>
                                          //   handleCheckboxChange(e, index)
                                          // }
                                        />
                                      </td>
                                    </tr>
                                  </>
                                );
                              })}
                            {selectedDropDownValue != 4 &&
                              statenew
                                ?.filter(
                                  (item) =>
                                    item.Module !== "Accounts" &&
                                    item.ItemName.toLowerCase().includes(
                                      searchValue.toLowerCase()
                                    ) &&
                                    (selectedCategoryForSearch
                                      ? item.CategoryID ===
                                        selectedCategoryForSearch
                                      : true)
                                )
                                .map((item, index) => {
                                  const filteredIndex = statenew.indexOf(item);
                                  return (
                                    <>
                                      <tr
                                        key={item.modifyid}
                                        className={
                                          "gridrow-" +
                                          (filteredIndex % 2 ? "even" : "odd")
                                        }
                                      >
                                        <td rowSpan={2}>{filteredIndex + 1}</td>
                                        {/* <td></td> */}
                                        <td colSpan={7} className="p-1">
                                          <Link
                                            type="button"
                                            onClick={(e) =>
                                              handleItemsDetailsData(item)
                                            }
                                            data-bs-target="#ItemsDetailsModal"
                                            data-bs-toggle="modal"
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <p className="word-break-data">
                                              {item.VariationName != "" &&
                                              item.VariationName != null
                                                ? item.VariationName
                                                : item.ItemName}
                                            </p>
                                            {/* {item.ItemName} (
                                            {item.VariationName}) */}
                                            {/* ({item.VariationName}) */}
                                          </Link>
                                        </td>
                                      </tr>
                                      <tr
                                        key={item.modifyid}
                                        className={
                                          "gridrow-" +
                                          (filteredIndex % 2 ? "even" : "odd")
                                        }
                                      >
                                        <td className="table-control-td">
                                          <span className="table-control-lable">
                                            Price
                                          </span>
                                          <input
                                            type="number"
                                            value={item.Price}
                                            // className="form-control pricecontrol"
                                            className="form-control form-control-sm"
                                            onChange={(e) =>
                                              handlePriceChange(
                                                filteredIndex,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </td>

                                        <td className="table-control-td">
                                          <span className="table-control-lable">
                                            Qty
                                          </span>
                                          <input
                                            type="number"
                                            value={item.itemquantity}
                                            // defaultValue={
                                            //   item.itemquantity
                                            //     ? item.itemquantity
                                            //     : 0
                                            // }
                                            className="form-control form-control-sm"
                                            // min={0}
                                            // max={item.ItemCurrentQuantity}
                                            onChange={(e) =>
                                              handleQuantityChange(
                                                filteredIndex,
                                                e.target.value
                                              )
                                            }
                                          />
                                          {validationErrors[filteredIndex] && (
                                            <p className="text-danger">
                                              {validationErrors[filteredIndex]}
                                            </p>
                                          )}
                                        </td>

                                        {/* value={entireSaleDiscount}
                            onChange={handleEntireSaleDiscountChange} */}
                                        {(selectedPriceForSale == 1 ||
                                          selectedPriceForSale == "" ||
                                          selectedPriceForSale == null) && (
                                          <td className="table-control-td">
                                            <span className="table-control-lable">
                                              Discount
                                            </span>
                                            <input
                                              type="number"
                                              value={item.itemdiscount}
                                              // defaultValue={
                                              //   item.itemdiscount
                                              //     // ? item.itemdiscount
                                              //     // : 0
                                              // }
                                              className="form-control form-control-sm"
                                              onChange={(e) =>
                                                handleDiscountChange(
                                                  filteredIndex,
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </td>
                                        )}
                                        <td className="table-control-td">
                                          <span className="table-control-lable">
                                            Total
                                          </span>
                                          <input
                                            type="number"
                                            // value={calculateTotal(item.UnitPrice, item.itemquantity, item.itemdiscount)}
                                            value={item.Total}
                                            className="form-control form-control-sm"
                                            // style={{ width: "max-content" }}
                                            onChange={(e) =>
                                              handleTotalChange(
                                                filteredIndex,
                                                e.target.value
                                              )
                                            }
                                          />
                                          {/* {calculateTotal(item.UnitPrice, item.itemquantity, item.itemdiscount)} */}
                                        </td>

                                        {/* <td className="text-center"> */}
                                        <td>
                                          <Link
                                            className="confirm-text"
                                            title="Delete"
                                            style={{ fontSize: "12px" }}
                                            onClick={() =>
                                              handleItemsDelete(index)
                                            }
                                          >
                                            <i
                                              className="fa fa-trash text-red fa-2x"
                                              data-bs-toggle="tooltip"
                                              title="Delete"
                                            ></i>
                                          </Link>
                                        </td>
                                        {/* <td className="text-center"> */}
                                        <td>
                                          {isContentVisible && (
                                            <input
                                              className="form-check-input form-control"
                                              // style={{ width: "1.5em", height: "1.5em", }}
                                              type="checkbox"
                                              name={`CheckBox${index}`}
                                              id={`CheckBox${index}`}
                                              defaultChecked={item.Ischecked}
                                              onChange={(e) =>
                                                handleCheckboxChange(e, index)
                                              }
                                            />
                                          )}
                                        </td>
                                      </tr>

                                      {drill && (
                                        <tr
                                          className={
                                            "gridrow-" +
                                            (filteredIndex % 2 ? "even" : "odd")
                                          }
                                        >
                                          <td colSpan={8} className="p-0">
                                            <div className="d-flex bottom-table">
                                              {/* <span className="m-2"></span> */}
                                              <span className="m-2 word-break-data">
                                                Category: {item?.CategoryName}
                                              </span>
                                              <span className="m-2">
                                                Stock:{" "}
                                                {item.ItemCurrentQuantity}
                                              </span>
                                              <span className="m-2">
                                                UPC/EAN/ISBN: {item.Itemnumber}{" "}
                                              </span>
                                              {/* <span className="m-2">Cost: {item.CostPrice}</span> */}
                                              <span className="m-2">
                                                Selling Price: {item.UnitPrice}
                                              </span>
                                              <span className="m-2">
                                                Tax:{" "}
                                                <Link
                                                  type="button"
                                                  // data-bs-target="#EditModal"
                                                  data-bs-target={`#EditModal-${item.VariationId}`}
                                                  data-bs-toggle="modal"
                                                  style={{
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  Edit Taxes
                                                </Link>
                                              </span>

                                              <EditTax
                                                callback={callbackHandleEditTax}
                                                index={index}
                                                VariationID={item.VariationId}
                                                ItemID={item.ItemId}
                                              />
                                            </div>
                                          </td>
                                        </tr>
                                      )}
                                    </>
                                  );
                                })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column col-md-4">
            <div class="">
              <div className="card col-md-12">
                <div className="card-body" style={{ padding: "10px" }}>
                  {/* More Button (...)  */}
                  <div className="btn-group mb-3">
                    {/* {paramObject.id>0 ?<Link
                      to="/sales-customer-facing-display"
                      title="Customer Facing Display"
                      // className="dropdown-item"
                      className="btn btn-outline-primary"
                    >
                      <i className="fas fa-desktop fs-6 me-1"></i> Customer
                      Facing Display
                    </Link> :""} */}
                    {/* <button
                      type="button"
                      className="btn btn-outline-secondary dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="fas fa-ellipsis-h me-1 fs-6"></i>
                    </button> */}
                    {/* <ul className="dropdown-menu">
                      <li>
                        <Link
                          to="/sales-customer-facing-display"
                          title="Customer Facing Display"
                          className="dropdown-item"
                        >
                          <i className="fas fa-desktop fs-6 me-1"></i> Customer
                          Facing Display
                        </Link>
                      </li>
                    </ul> */}

                    {/* <ul className="dropdown-menu">
                      {selectedDropDownValue != 4 && (
                        <>
                          <li>
                            <Link data-bs-target="#saleGiftCard" data-bs-toggle="modal" title="Sell GiftCard" className="dropdown-item" style={{ display: "flex", alignItems: "center", }} >
                              <i className="fas fa-gift fs-6 me-1"></i> Sell GiftCard
                            </Link>
                          </li>
                          <li>
                            <Link to="/suspended-sales" title="Suspended Sales" className="dropdown-item">
                              <i className="far fa-list-alt fs-6 me-1"></i> Suspended Sales
                            </Link>
                          </li>
                          <li>
                            <Link to="/deliveries" title="Delivery Orders" className="dropdown-item">
                              <i className="far fa-list-alt fs-6 me-1"></i> Delivery Orders
                            </Link>
                          </li>
                          <li>
                            <Link to="/search-sales" title="Search Sale" className="dropdown-item" >
                              <i className="fas fa-search fs-6 me-1"></i> Search Sales
                            </Link>
                          </li>
                          <li>
                            <Link to="/batch-sales" title="Batch sale" className="dropdown-item">
                              <i className="fas fa-shopping-bag fs-6 me-1"></i> Batch sale
                            </Link>
                          </li>
                        </>
                      )}

                      <li>
                        <Link className="dropdown-item" data-bs-target="#LookupReceiptSaleModal" data-bs-toggle="modal">
                          <i className="far fa-file-alt fs-6 me-1"></i> Lookup Receipt
                        </Link>
                      </li>
                      <li>
                        <Link to="/sales-receipt" title="Show last sale receipt" className="dropdown-item" >
                          <i className="fas fa-receipt fs-6 me-1"></i>Show last sale receipt
                        </Link>
                      </li>
                      <li>
                        <Link to="/sales-customer-facing-display" title="Customer Facing Display" className="dropdown-item">
                          <i className="fas fa-desktop fs-6 me-1"></i> Customer Facing Display
                        </Link>
                      </li>
                      <li>
                        <Link to="/custom-field-sales-configuration" title="Custom Field Configuration" className="dropdown-item">
                          <i className="fas fa-wrench fs-6 me-1"></i> Custom Field Configuration
                        </Link>
                      </li>
                      <li>
                        <Link to="/sales-all-receipt" title="Show all receipts for today" className="dropdown-item">
                          <i className="far fa-file-alt fs-6 me-1"></i> Show all receipts for today
                        </Link>
                      </li>
                    </ul>
                    <SalesGiftCard callback={callback4} /> */}
                  </div>

                  <div>
                    {/* <button
                      className="btn btn-sm btn-outline-primary m-1 mb-2"
                      onClick={handleRemoveLocalData}
                    >
                      <div className="d-flex align-items-center">
                        <img
                          src={Closed}
                          style={{
                            marginRight: "0.5rem",
                            width: "0.9rem",
                            height: "0.9rem",
                          }}
                        />{" "}
                        Cancel Field Data
                      </div>
                    </button> */}
                    <button
                      className="btn btn-sm btn-outline-primary w-100  mb-2"
                      style={{ textAlign: "center" }}
                      onClick={handleRemoveLocalData}
                    >
                      Clear All Data
                    </button>
                  </div>

                  {/* Suspend & Cancel Button Content */}
                  {statenew &&
                  statenew.length > 0 &&
                  selectedDropDownValue == 3 ? (
                    <div className="row mb-2">
                      <div
                        className="col-md-12"
                        // onClick={handleSuspend}
                        // onClick={handleSubmit}
                      >
                        <button
                          className="btn btn-sm btn-outline-primary m-1 mb-2"
                          data-bs-target="#SuspendedModal"
                          data-bs-toggle="modal"
                          // onClick={() => { handleCompleteSale("suspend"); }}
                          // onClick={handleSuspendClick}
                        >
                          <div className="d-inline-flex align-items-center">
                            <i class="fas fa-solid fa-pause me-1"></i> Suspend
                          </div>
                        </button>
                        <button
                          className="btn btn-sm btn-outline-primary m-1 mb-2"
                          data-bs-toggle="modal"
                          data-bs-target="#CancelModal"
                        >
                          <div className="d-flex align-items-center">
                            <img
                              src={Closed}
                              style={{
                                marginRight: "0.5rem",
                                width: "0.9rem",
                                height: "0.9rem",
                              }}
                            />{" "}
                            Cancel
                          </div>
                        </button>
                      </div>

                      <div className="col-md-3"></div>
                      <CancelConfirmation
                        handleCancelPopup={handleCancelPopup}
                      />
                    </div>
                  ) : null}

                  {/* Customer Details With Card */}
                  {!selectedOption ? (
                    <div className="input-group flex-nowrap">
                      <span className="input-group-text" id="addon-wrapping">
                        <a href="manage-customers">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-person-plus"
                            viewBox="0 0 16 16"
                          >
                            <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                            <path
                              fillRule="evenodd"
                              d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                            />
                          </svg>
                        </a>
                      </span>

                      <Select
                        className="w-100"
                        name="customerid"
                        id="customerid"
                        placeholder="Select Customer"
                        options={options}
                        value={selectedOption}
                        styles={selectStyles}
                        onChange={(e) => {
                          setSelectedOption(e);
                          handleSelectChange(e);
                        }}
                      />
                    </div>
                  ) : (
                    <>
                      {/* <SalesCard
                        customerforcard={customerName}
                        value={selectedOption}
                        onCancel={handleCancelClick}
                        visible={selectedOption === customerId}
                      /> */}
                      <SalesCard
                        callback={callbackDelivery}
                        data={selectedcustomer}
                        onCancel={handleCancelClick}
                        visible={selectedcustomer.Id === customerId}
                        salesdeliverydata={selectedSalesDeliveryData}
                        saleDropdown={selectedDropDownValue}
                      />
                    </>
                  )}

                  {/* This is the code before the accordian */}

                  {/* {selectedDropDownValue !== 4 && (
                    <div className="d-flex flex-column">
                      <div className="p-2">
                        <span>
                          {selectedDropDownValue === 1
                            ? "Message on Invoice:"
                            : selectedDropDownValue === 2
                              ? "Message displayed on credit memo:"
                              : selectedDropDownValue === 3
                                ? "Message displayed on estimate:"
                                : ""}{" "}
                        </span>
                        <div>
                          {showEditInvoice ? (
                            <div>
                              <form
                                onSubmit={AddMessageInvoice}
                                className="d-flex"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  border: "1px solid lightgray",
                                  borderRadius: "5px",
                                  width: "100%",
                                }}
                              >
                                <input
                                  id="InvoiceMessage"
                                  name="InvoiceMessage"
                                  // placeholder="Invoice Message"
                                  className="form-control w-100"
                                  // onChange={(event) =>
                                  //   handleChangeAccountSalesData(event, "InvoiceMessage")
                                  // }
                                  defaultValue={accountSaleData?.InvoiceMessage}
                                  style={{ border: "none" }}
                                ></input>

                                <button
                                  className="btn btn-outline-primary btn-sm m-1"
                                  type="submit"
                                >
                                  <i
                                    className="fa fa-check"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                                <div
                                  className="btn btn-outline-danger btn-sm m-1"
                                  onClick={() => setShowEditInvoice(false)}
                                >
                                  <i
                                    className="fa fa-times"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              </form>
                            </div>
                          ) : accountSaleData?.InvoiceMessage == "" ? (
                            <div>
                              <i
                                class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                aria-hidden="true"
                              ></i>

                              <></>
                              <i
                                className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                style={{ fontSize: "16px", cursor: "pointer" }}
                                onClick={handleClickEdit}
                              ></i>
                            </div>
                          ) : (
                            <>
                              <i
                                class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                aria-hidden="true"
                              ></i>
                              {accountSaleData?.InvoiceMessage}
                              <i
                                className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                style={{ fontSize: "16px", cursor: "pointer" }}
                                onClick={handleClickEdit}
                              ></i>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="p-2">
                        <span>
                          {selectedDropDownValue === 1
                            ? "Message on Statement:"
                            : selectedDropDownValue === 2
                              ? "Message displayed on statement:"
                              : selectedDropDownValue === 3
                                ? "Message displayed on statement:"
                                : ""}{" "}
                        </span>
                        <div>
                          {showEditStatement ? (
                            <div>
                              <form
                                onSubmit={AddMessageStatement}
                                className="d-flex"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  border: "1px solid lightgray",
                                  borderRadius: "5px",
                                  width: "auto",
                                }}
                              >
                                <input
                                  id="InvoiceStatement"
                                  name="InvoiceStatement"
                                  // placeholder="Invoice Statement"
                                  className="form-control"
                                  // onChange={(event) =>
                                  //   handleChangeAccountSalesData(
                                  //     event,
                                  //     "InvoiceStatement"
                                  //     )
                                  //   }
                                  defaultValue={accountSaleData?.InvoiceStatement}
                                  style={{ border: "none" }}
                                ></input>
                                <button
                                  className="btn btn-outline-primary btn-sm m-1"
                                  type="submit"
                                >
                                  <i
                                    className="fa fa-check"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                                <div
                                  className="btn btn-outline-danger btn-sm m-1"
                                  onClick={() => setShowEditStatement(false)}
                                >
                                  <i
                                    className="fa fa-times"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              </form>
                            </div>
                          ) : accountSaleData?.InvoiceStatement == "" ? (
                            <div>
                              <i
                                class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                aria-hidden="true"
                              ></i>

                              <></>
                              <i
                                className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                style={{ fontSize: "16px", cursor: "pointer" }}
                                onClick={handleClick}
                              ></i>
                            </div>
                          ) : (
                            <>
                              <i
                                class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                aria-hidden="true"
                              ></i>
                              {accountSaleData?.InvoiceStatement}
                              <i
                                className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                style={{ fontSize: "16px", cursor: "pointer" }}
                                onClick={handleClick}
                              ></i>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )} */}

                  {selectedDropDownValue !== 4 && (
                    <div className="d-flex flex-column">
                      <div className="p-2">
                        <div
                          className="accordion-header"
                          style={{ cursor: "pointer" }}
                          onClick={toggleAccordion}
                        >
                          <button
                            class="accordion-button dropdown-toggle"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            <span>
                              {selectedDropDownValue === 1
                                ? "Message on Invoice:"
                                : selectedDropDownValue === 2
                                ? "Message displayed on credit memo:"
                                : selectedDropDownValue === 3
                                ? "Message displayed on estimate:"
                                : ""}{" "}
                            </span>
                          </button>
                        </div>
                        {isAccordionOpen && (
                          <div className="accordian">
                            <div>
                              {showEditInvoice ? (
                                <div>
                                  <form
                                    onSubmit={AddMessageInvoice}
                                    className="d-flex"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      border: "1px solid lightgray",
                                      borderRadius: "5px",
                                      width: "100%",
                                    }}
                                  >
                                    <input
                                      id="InvoiceMessage"
                                      name="InvoiceMessage"
                                      // placeholder="Invoice Message"
                                      className="form-control w-100"
                                      // onChange={(event) =>
                                      //   handleChangeAccountSalesData(event, "InvoiceMessage")
                                      // }
                                      defaultValue={
                                        accountSaleData?.InvoiceMessage
                                      }
                                      style={{ border: "none" }}
                                    ></input>

                                    <button
                                      className="btn btn-outline-primary btn-sm m-1"
                                      type="submit"
                                    >
                                      <i
                                        className="fa fa-check"
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                    <div
                                      className="btn btn-outline-danger btn-sm m-1"
                                      onClick={() => setShowEditInvoice(false)}
                                    >
                                      <i
                                        className="fa fa-times"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                  </form>
                                </div>
                              ) : accountSaleData?.InvoiceMessage == "" ? (
                                <div>
                                  <i
                                    class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                    aria-hidden="true"
                                  ></i>

                                  <></>
                                  <i
                                    className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                    style={{
                                      fontSize: "16px",
                                      cursor: "pointer",
                                    }}
                                    onClick={handleClickEdit}
                                  ></i>
                                </div>
                              ) : (
                                <>
                                  <i
                                    class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                    aria-hidden="true"
                                  ></i>
                                  {accountSaleData?.InvoiceMessage}
                                  <i
                                    className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                    style={{
                                      fontSize: "16px",
                                      cursor: "pointer",
                                    }}
                                    onClick={handleClickEdit}
                                  ></i>
                                </>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      {/* <div className="p-2">
                        <span>
                          {selectedDropDownValue === 1
                            ? "Message on Statement:"
                            : selectedDropDownValue === 2
                              ? "Message displayed on statement:"
                              : selectedDropDownValue === 3
                                ? "Message displayed on statement:"
                                : ""}{" "}
                        </span>
                        <div>
                          {showEditStatement ? (
                            <div>
                              <form
                                onSubmit={AddMessageStatement}
                                className="d-flex"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  border: "1px solid lightgray",
                                  borderRadius: "5px",
                                  width: "auto",
                                }}
                              >
                                <input
                                  id="InvoiceStatement"
                                  name="InvoiceStatement"
                                  // placeholder="Invoice Statement"
                                  className="form-control"
                                  // onChange={(event) =>
                                  //   handleChangeAccountSalesData(
                                  //     event,
                                  //     "InvoiceStatement"
                                  //     )
                                  //   }
                                  defaultValue={accountSaleData?.InvoiceStatement}
                                  style={{ border: "none" }}
                                ></input>
                                <button
                                  className="btn btn-outline-primary btn-sm m-1"
                                  type="submit"
                                >
                                  <i
                                    className="fa fa-check"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                                <div
                                  className="btn btn-outline-danger btn-sm m-1"
                                  onClick={() => setShowEditStatement(false)}
                                >
                                  <i
                                    className="fa fa-times"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              </form>
                            </div>
                          ) : accountSaleData?.InvoiceStatement == "" ? (
                            <div>
                              <i
                                class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                aria-hidden="true"
                              ></i>

                              <></>
                              <i
                                className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                style={{ fontSize: "16px", cursor: "pointer" }}
                                onClick={handleClick}
                              ></i>
                            </div>
                          ) : (
                            <>
                              <i
                                class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                aria-hidden="true"
                              ></i>
                              {accountSaleData?.InvoiceStatement}
                              <i
                                className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                style={{ fontSize: "16px", cursor: "pointer" }}
                                onClick={handleClick}
                              ></i>
                            </>
                          )}
                        </div>
                      </div> */}
                      <div className="p-2">
                        <div
                          className="accordion-header"
                          style={{ cursor: "pointer" }}
                          onClick={toggleAccordionOne}
                        >
                          <button
                            class="accordion-button dropdown-toggle"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            <span>
                              {selectedDropDownValue === 1 ||
                              selectedDropDownValue === 4
                                ? "Message on Statement:"
                                : selectedDropDownValue === 2
                                ? "Message displayed on statement:"
                                : selectedDropDownValue === 3
                                ? "Message displayed on statement:"
                                : ""}{" "}
                            </span>
                          </button>
                        </div>
                        {isAccordionOpenOne && (
                          <div className="accordion">
                            {showEditStatement ? (
                              <div>
                                <form
                                  onSubmit={AddMessageStatement}
                                  className="d-flex"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    border: "1px solid lightgray",
                                    borderRadius: "5px",
                                    width: "auto",
                                  }}
                                >
                                  <input
                                    id="InvoiceStatement"
                                    name="InvoiceStatement"
                                    // placeholder="Invoice Statement"
                                    className="form-control"
                                    // onChange={(event) =>
                                    //   handleChangeAccountSalesData(
                                    //     event,
                                    //     "InvoiceStatement"
                                    //     )
                                    //   }
                                    defaultValue={
                                      accountSaleData?.InvoiceStatement
                                    }
                                    style={{ border: "none" }}
                                  ></input>
                                  <button
                                    className="btn btn-outline-primary btn-sm m-1"
                                    type="submit"
                                  >
                                    <i
                                      className="fa fa-check"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                  <div
                                    className="btn btn-outline-danger btn-sm m-1"
                                    onClick={() => setShowEditStatement(false)}
                                  >
                                    <i
                                      className="fa fa-times"
                                      aria-hidden="true"
                                    ></i>
                                  </div>
                                </form>
                              </div>
                            ) : accountSaleData?.InvoiceStatement == "" ? (
                              <div>
                                <i
                                  class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                  aria-hidden="true"
                                ></i>

                                <></>
                                <i
                                  className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                  style={{
                                    fontSize: "16px",
                                    cursor: "pointer",
                                  }}
                                  onClick={handleClick}
                                ></i>
                              </div>
                            ) : (
                              <>
                                <i
                                  class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                  aria-hidden="true"
                                ></i>
                                {accountSaleData?.InvoiceStatement}
                                <i
                                  className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                  style={{
                                    fontSize: "16px",
                                    cursor: "pointer",
                                  }}
                                  onClick={handleClick}
                                ></i>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* <div className="card-body text-secondary">
                  <div className="row">
                    <div className="col-md-6">
                      {selectedcustomer.FirstName} {selectedcustomer.LastName}
                    </div>
                    <div className="col-md-6">
                      <div className="pull-right">{selectedcustomer.Email}</div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">{selectedcustomer.Address1}</div>
                    <div className="col-md-6">
                      <div className="pull-right">
                        {selectedcustomer.PhoneNumber}
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
            <div class="">
              <div className="card col-md-12">
                <div className="card-body">
                  {selectedDropDownValue != 4 && (
                    <>
                      {(selectedPriceForSale == 1 ||
                        selectedPriceForSale == "" ||
                        selectedPriceForSale == null) && (
                        <div className="row mt-2">
                          <div className="col-md-6">
                            <label className="form-label">
                              Discount all Items by Percent (%) :
                            </label>
                          </div>
                          <div className="col-md-6">
                            <input
                              type="number"
                              id="discount"
                              name="discount"
                              placeholder="Discount"
                              className="form-control form-control-sm"
                              value={entireSaleDiscount}
                              onChange={(e) =>
                                handleEntireSaleDiscountChange(e.target.value)
                              }
                            />
                          </div>
                        </div>
                      )}
                      <div className="row mt-2">
                        <div className="col-md-6">
                          <label className="form-label">
                            Discount Entire Sale ($):
                          </label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="number"
                            id="discount"
                            name="discount"
                            placeholder="Discount"
                            className="form-control form-control-sm"
                            value={commonDiscount}
                            onChange={handleCommonDiscountChange}
                          />
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-6">
                          <label className="form-label">Discount Reason:</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            // id="comment"
                            // name="comment"
                            placeholder="Comment"
                            value={reason}
                            className="form-control form-control-sm"
                            onChange={handleChangeReason}
                          />
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-6 d-flex align-items-center">
                          <label>Sub Total ($): </label>
                          <Link
                            type="button"
                            data-bs-target="#EditModal"
                            data-bs-toggle="modal"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            [Edit Taxes]
                          </Link>
                          <EditTax
                            callback={callbackHandleEditTax}
                            VariationID={""}
                            ItemID={""}
                          />
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            id="SubTotal"
                            name="SubTotal"
                            placeholder="Sub Total"
                            className="form-control form-control-sm"
                            // value={Number(netSubAmount).toFixed(2)}
                            // value={Number(netAmountValue).toFixed(2)}
                            value={
                              paramObject.id === undefined
                                ? Number(
                                    LStotalAmt == undefined
                                      ? 0
                                      : LStotalAmt - commonDiscount
                                  ).toFixed(2)
                                : Number(netSubAmount).toFixed(2)
                            }
                          />
                        </div>
                      </div>
                      {deliveryFees > 0 && (
                        <div className="row mt-2">
                          <div className="col-md-6">
                            <label className="form-label">
                              Delivery Fees ($):
                            </label>
                          </div>
                          <div className="col-md-6">{deliveryFees}</div>
                        </div>
                      )}

                      <div className="row mt-2">
                        <div className="col-md-12">
                          <ul className="list-group tax mt-2">
                            {taxXml.map(
                              (tax, index) =>
                                deletedPaymentIndexTax !== index && (
                                  <li
                                    key={index}
                                    className="list-group-item d-flex justify-content-between align-items-center"
                                  >
                                    <Link
                                      type="button"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                      onClick={(e) =>
                                        handleDeleteTax(e, tax, index)
                                      }
                                    >
                                      <img
                                        src={Closed}
                                        style={{
                                          marginRight: "0.5rem",
                                          width: "0.9rem",
                                          height: "0.9rem",
                                        }}
                                      />
                                    </Link>
                                    <span className="key">
                                      <i className="icon ion-android-cancel"></i>
                                      {tax.TaxPercent}%
                                      <span className="ms-2">
                                        {tax.TaxName}
                                      </span>
                                    </span>
                                    {/* <span className="value ms-auto">
                                      {(
                                        (totalRef.current * tax.TaxPercent) /
                                        100
                                      ).toFixed(2)}
                                    </span> */}
                                    {/* <span className="value ms-auto">
                                      {tax.type === "itemTax"
                                        ? ((totalRef.current * tax.TaxPercent) / 100) / (statenew.length)
                                        : (totalRef.current * tax.TaxPercent) / 100
                                      }
                                    </span> */}
                                    {/* <span className="value ms-auto">
                                      {tax.type === "itemTax"
                                        ? (totalRef.current * tax.TaxPercent) /
                                          100 /
                                          statenew.length
                                        : (totalRef.current * tax.TaxPercent) /
                                          100 /
                                          (statenew.length -
                                            [
                                              ...new Set(
                                                taxXml.map(
                                                  (item) => item.TaxItemId
                                                )
                                              ),
                                            ].length)}
                                    </span> */}
                                    <span className="value ms-auto">
                                      {/* {tax.type === "itemTax"
                                        ? calculateItemTax(
                                            totalRef.current,
                                            tax.TaxPercent,
                                            statenew.length
                                          )
                                        : calculateOtherTax(
                                            totalRef.current,
                                            tax.TaxPercent,
                                            statenew.length,
                                            taxXml
                                          )
                                        ? calculateOtherTax(
                                            totalRef.current,
                                            tax.TaxPercent,
                                            statenew.length,
                                            taxXml
                                          )
                                        : calculateDeliveryTax(
                                            totalRef.current,
                                            tax.TaxPercent
                                          )} */}
                                      {tax.type === "itemTax"
                                        ? calculateItemTax(
                                            totalRef.current,
                                            tax.TaxPercent,
                                            statenew.length
                                          )
                                        : tax.type === "deliveryTax"
                                        ? calculateDeliveryTax(
                                            totalRef.current,
                                            tax.TaxPercent
                                          )
                                        : calculateOtherTax(
                                            // totalRef.current,
                                            paramObject.id === undefined
                                              ? Number(
                                                  LStotalAmt == undefined
                                                    ? 0
                                                    : LStotalAmt -
                                                        commonDiscount
                                                ).toFixed(2)
                                              : Number(netSubAmount).toFixed(2),
                                            tax.TaxPercent,
                                            statenew.length,
                                            taxXml
                                          )}
                                    </span>
                                  </li>
                                )
                            )}
                          </ul>
                        </div>
                      </div>
                    </>
                  )}

                  <div className="row mt-2">
                    <div className="col-md-6">
                      <div className="amount-box">
                        <div
                          className="amount-box-header text-center"
                          name="total"
                        >
                          Total
                        </div>
                        <div className="amount-box-content">
                          <div
                            className="amount-box-value"
                            data-speed="1000"
                            data-currency="$"
                            data-decimals="2"
                          >
                            {
                              (selectedDropDownValue == 1 ||
                                selectedDropDownValue == 2 ||
                                selectedDropDownValue == 3) &&
                                // (isChangedData ? (
                                //   <>${parseFloat(netAmount).toFixed(2)}</>
                                // ) : (
                                //   <>${parseFloat(netAmountValue).toFixed(2)}</>
                                // ))

                                (paramObject.id !== undefined ? (
                                  <>${Number(netAmount).toFixed(2)}</>
                                ) : (
                                  <>
                                    {/* {commonDiscount ==""? 0: commonDiscount} hello */}
                                    $
                                    {LStotalAmt == undefined
                                      ? 0
                                      : (
                                          Number(LStotalAmt) -
                                          Number(commonDiscount) +
                                          Number(
                                            isNaN(deliveryFees)
                                              ? 0
                                              : deliveryFees
                                          ) +
                                          (totalTaxAmount ? totalTaxAmount : 0)
                                        )?.toFixed(2)}
                                  </>
                                ))
                              // <>${Number(netAmount).toFixed(2)}</>
                            }
                            {selectedDropDownValue == 4 && (
                              <>
                                $
                                {isNaN(parseFloat(sumamount))
                                  ? "0.00"
                                  : parseFloat(sumamount).toFixed(2)}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="row mt-3">
                        {(selectedDropDownValue == 1 ||
                          selectedDropDownValue == 2 ||
                          selectedDropDownValue == 3) && (
                          <div>
                            <div className="col-md-12">
                              <label className="form-label">Total Item:</label>
                              <span className="ms-5">
                                {
                                  statenew.filter(
                                    (item) => item.Module !== "Accounts"
                                  ).length
                                }
                              </span>
                            </div>

                            <div className="col-md-12">
                              <label className="form-label">
                                Total Quantity:
                              </label>
                              {/* <span className="ms-4">{totalQuantity}</span> */}
                              {paramObject.id === undefined ? (
                                <span className="ms-4">
                                  {LSTQty == undefined ? 0 : LSTQty}
                                </span>
                              ) : (
                                <span className="ms-4">{totalQuantity}</span>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                      <div className="amount-box">
                        <div className="amount-box-header">Amount Due</div>
                        <div className="amount-box-content">
                          <div className="amount-box-value1">
                            {parseFloat(Compairamount).toFixed(2)}
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                  {statenew && statenew.length > 0 ? (
                    <div>
                      {payments.length > 0 ? <span>Payments :</span> : ""}
                      <ul className="list-group payments">
                        {payments.map(
                          (payment, index) =>
                            deletedPaymentIndex !== index && (
                              <li
                                key={index}
                                className="list-group-item d-flex justify-content-between align-items-center"
                              >
                                {/* <Link
                                  type="button"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  onClick={() => handleDeletePayment(index)}
                                >
                                  <img
                                    src={Closed}
                                    style={{
                                      marginRight: "0.5rem",
                                      width: "0.9rem",
                                      height: "0.9rem",
                                    }}
                                  />
                                </Link> */}
                                <span className="key">
                                  <i className="icon ion-android-cancel"></i>
                                  {/* for the Insert time */}
                                  {paymentTypeMap[payment.PaymentId]}

                                  {/* // for the Update Time */}
                                  {paymentTypeMap[payment.ID]}
                                </span>

                                <span className="value ms-auto">
                                  {Number(payment.Paymentamount).toFixed(2)}
                                </span>
                              </li>
                            )
                        )}
                      </ul>
                      {selectedDropDownValue != 4 && (
                        <>
                          <div className="row mt-2 border-bottom">
                            <div className="col-md-6 mb-2">
                              <label className="form-label">
                                {" "}
                                Payment Curreny:{" "}
                              </label>
                            </div>
                            <div className="col-md-6 mb-2">
                              <select
                                className="form-select form-select-sm"
                                value={paymentCurrency}
                                onChange={(event) =>
                                  setPaymentCurrency(event.target.value)
                                }
                              >
                                <option value="1">USD</option>
                              </select>
                            </div>
                          </div>
                          {/* <div className="row mt-2 border-bottom">
                            <label className="form-label">Add Coupon Codes</label>
                            <div className="input-group mb-2">
                              <span className="input-group-text"><i className="fa fa-tag"></i></span>
                              <input className="form-control" id="CouponCode" onChange={handleChangeCupon} />
                            </div>
                          </div> */}
                        </>
                      )}

                      {/* <div className="row mt-2 border-bottom">
                        <label className="form-label" name="paymenttypeid">
                          Add Payment
                        </label>
                        <div className="mb-3">
                          {paymentTypeDropdown &&
                            paymentTypeDropdown.map((option, index) => (
                              <button
                                key={index}
                                type="button"
                                className={`btn btn-outline-primary me-1 mb-1 ${selectedPayment &&
                                  selectedPayment.id === option.ID
                                  ? "active btn-primary"
                                  : ""
                                  }`}
                                onClick={() =>
                                  handlePayment(
                                    option.Paymenttypename,
                                    option.ID,
                                    option.Paymenttypename
                                  )
                                }
                              >
                                {option.Paymenttypename}
                              </button>
                            ))}

                          <div className="input-group mt-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="0.00"
                              value={amountToSubtract}
                              onChange={handleAmountChange}
                            />

                            {Compairamount === parseFloat(amountToSubtract) ? (
                              <span className="input-group-append">
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  data-bs-target="#SaleCompleteModal"
                                  data-bs-toggle="modal"
                                // onClick={() => {
                                //   handleCompleteSale("complete");

                                // }}
                                >
                                  Complete Sale
                                </button>

                              </span>
                            ) : (
                              <span className="input-group-append">
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() => {
                                    handleCompleteSale("complete");
                                  }}
                                >
                                  Add Payment
                                </button>
                              </span>
                            )}
                          </div>
                        </div>
                      </div> */}

                      {selectedDropDownValue != 4 && (
                        <>
                          <div className="row border-bottom">
                            <div className="col-md-12 mb-2 mt-2 ">
                              {restirctedit == 0 && (
                                <button
                                  type="button"
                                  className="btn btn-primary w-100"
                                  data-bs-target="#SaleCompleteModal"
                                  data-bs-toggle="modal"
                                >
                                  {selectedDropDownValue == 1 && (
                                    <>Complete Sale</>
                                  )}
                                  {selectedDropDownValue == 2 && (
                                    <>Complete Return</>
                                  )}
                                  {selectedDropDownValue == 3 && (
                                    <>Generate Estimate</>
                                  )}
                                </button>
                              )}
                            </div>
                          </div>
                          <div className="row border-bottom">
                            <div className="col-md-12 mb-2 mt-2">
                              <textarea
                                className="form-control"
                                id="comment"
                                name="comment"
                                rows="3"
                                placeholder="Comments"
                                value={comment}
                                onChange={handleChangeComments}
                              ></textarea>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="form-group">
                        {/* <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="showcommentonreceipt"
                            name="showcommentonreceipt"
                            onChange={handleCheckboxChange}
                          />
                          <label className="form-check-label">
                            Show comments on receipt
                          </label>
                        </div> */}

                        {selectedDropDownValue != 4 &&
                          customFields.map((data, index) => (
                            <>
                              <div className="row">
                                <label
                                  className="col-form-label col-md-4 form-label mb-2"
                                  key={index}
                                >
                                  {data.Name}
                                </label>

                                <div className="col-md-8">
                                  {data.TypeName === "Text" ? (
                                    <input
                                      key={index}
                                      type="text"
                                      className="form-control form-control-sm"
                                      onChange={(event) => {
                                        handleChange(event);
                                        handleCustomFieldsValues(
                                          event,
                                          data.TypeName,
                                          data.Name
                                        );
                                      }}
                                      id={data.TypeName}
                                      name={data.Id}
                                      // value={data.Value}
                                    />
                                  ) : data.TypeName === "E-Mail" ? (
                                    <input
                                      key={index}
                                      type="email"
                                      className="form-control form-control-sm"
                                      onChange={(event) => {
                                        handleChange(event);
                                        handleCustomFieldsValues(
                                          event,
                                          data.TypeName,
                                          data.Name
                                        );
                                      }}
                                      id={data.TypeName}
                                      name={data.Id}
                                      // value={data.Value}
                                    />
                                  ) : data.TypeName === "Dropdown" ? (
                                    <>
                                      <Select
                                        key={index}
                                        id={data.TypeName}
                                        name={data.Id}
                                        backspaceRemovesValue={false}
                                        controlShouldRenderValue={true}
                                        hideSelectedOptions={true}
                                        isClearable={true}
                                        onChange={(event) => {
                                          handleCustomFieldsValues(
                                            event,
                                            data.TypeName,
                                            data.Id
                                          );
                                          setSelectedCustomField(event, index);
                                        }}
                                        options={data.Optionvalue.split(
                                          ","
                                        ).map((option) => ({
                                          label: option,
                                          value: option,
                                          selected: option === data.Id,
                                        }))}
                                        placeholder="Select"
                                        styles={selectStyles}
                                        defaultValue={
                                          data.Id !== null && data.Id !== ""
                                            ? {
                                                label: [data.Id],
                                                value: [data.Id],
                                              }
                                            : ""
                                        }
                                      />
                                    </>
                                  ) : data.TypeName === "Checkbox" ? (
                                    <input
                                      key={index}
                                      className="form-check-input form-control"
                                      style={{
                                        width: "1.5em",
                                        height: "1.5em",
                                      }}
                                      type="checkbox"
                                      id={data.TypeName}
                                      name={data.Id}
                                      onChange={(event) => {
                                        handleCustomFieldsValues(
                                          event,
                                          data.TypeName,
                                          data.Name
                                        );
                                        handleChange(event);
                                      }}
                                      onInput={handleSelectCustomCheckBox}
                                      // checked={data.Value == "on"?true:false}
                                    />
                                  ) : data.TypeName === "Website" ? (
                                    <input
                                      key={index}
                                      type="text"
                                      className="form-control form-control-sm"
                                      onChange={(event) => {
                                        handleChange(event);
                                        handleCustomFieldsValues(
                                          event,
                                          data.TypeName,
                                          data.Name
                                        );
                                      }}
                                      id={data.TypeName}
                                      name={data.Id}
                                      // value={data.Value}
                                    />
                                  ) : data.TypeName === "PhoneNumber" ? (
                                    <input
                                      key={index}
                                      type="number"
                                      className="form-control form-control-sm"
                                      id={data.TypeName}
                                      name={data.Id}
                                      value={data.Value}
                                      onChange={(event) => {
                                        handleChange(event);
                                        handleCustomFieldsValues(
                                          event,
                                          data.TypeName,
                                          data.Name
                                        );
                                      }}
                                    />
                                  ) : data.TypeName === "Date" ? (
                                    <input
                                      key={index}
                                      className="form-control form-control-sm"
                                      type="date"
                                      id={data.TypeName}
                                      name={data.Id}
                                      // value={data.Value}
                                      onChange={(event) => {
                                        handleChange(event);
                                        handleCustomFieldsValues(
                                          event,
                                          data.TypeName,
                                          data.Name
                                        );
                                      }}
                                    />
                                  ) : data.TypeName === "Image" ? (
                                    <>
                                      {/* <button onClick={()=> (console.log("selectedCustomImage",selectedCustomImage))}>Check</button> */}
                                      <div className="row">
                                        <FileInput
                                          type="file"
                                          key={index}
                                          className="form-control form-control-sm"
                                          id={data.TypeName}
                                          name={data.Id}
                                          value={selectedCustomImage}
                                          accept="image/*"
                                          handleChange={(event) => {
                                            _handleFileChange(event, index);
                                            handleCustomFieldsValues(
                                              event,
                                              data.TypeName,
                                              data.Name
                                            );
                                          }}
                                        />
                                      </div>
                                      <img
                                        src={`${
                                          formValues[data.Id]
                                            ? formValues[data.Id]
                                            : selectedCustomImage
                                        }`}
                                        className="ImagePreviewSize mt-3 mb-3"
                                      />
                                    </>
                                  ) : data.TypeName === "File" ? (
                                    <FileInput
                                      type="file"
                                      key={index}
                                      className="form-control form-control-sm"
                                      id={data.TypeName}
                                      name={data.Id}
                                      value={selectedCustomFile}
                                      handleChange={(event) => {
                                        // _handleFileChange(event, index);
                                        handleCustomFieldsValues(
                                          event,
                                          data.TypeName,
                                          data.Name
                                        );
                                      }}
                                    />
                                  ) : null}
                                </div>
                              </div>
                            </>
                          ))}
                      </div>
                    </div>
                  ) : null}

                  {statenew.length > 0 && selectedDropDownValue == 4 ? (
                    paramObject.id > 0 && restirctedit == 1 ? (
                      ""
                    ) : (
                      <div className="row border-bottom">
                        <div className="col-md-12 mb-2 mt-2 ">
                          <button
                            type="button"
                            className="btn btn-primary w-100"
                            data-bs-target="#SaleCompleteModal"
                            data-bs-toggle="modal"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    )
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <BatchSale callback={callback5} /> */}

      <div
        className={`modal ${modal ? "d-block" : ""}`}
        tabIndex="-1"
        style={{ background: "rgba(0,0,0,0.2)" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirmation</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <h6>
                    Payment transaction has been intiated, so you cant change
                    the type.
                  </h6>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setModal(false)}
              >
                Ok
              </button>
              {/* <button
                type="button"
                className="btn btn-secondary"
                // onClick={handleCancelDelete}
              >
                Cancel
              </button> */}
            </div>
          </div>
        </div>
      </div>

      <FilterModal callback={callbackItemGrid} runApi={runApi} />

      {/* <SuspendedConfirmation handleSuspend={handleSuspend} type="Sales" /> */}
      <SuspendedConfirmation handleSuspend={handleSubmit} type="Sales" />
      <SaleCompleteModal handleSubmit={handleSubmit} />
      {/* temp data comment for testing */}
      {/* <ItemsDetailsModal ItemsDetails={itemsDetailsData} /> */}
      <ItemsDetailsModal id={itemsDetailsData ? itemsDetailsData.ItemId : 0} />
    </>
  );
};

// Item SearchableDropdown
const SearchableDropdown = ({
  customerID,
  callback,
  disabled,
  readonly,
  value,
  callbackaccount,
}) => {
  // console.log(readonly, "readonlyuu");
  const token = localStorage.getItem("Token");
  const locationID = localStorage.getItem("Location");
  //const Clone = localStorage.getItem("Clone");
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    // fetchData();

    const timer = setTimeout(() => {
      if (inputValue) {
        // Make your API call here
        fetchData();
      }
    }, 500); // Adjust the delay according to your needs (in milliseconds)

    return () => {
      clearTimeout(timer);
    };
  }, [inputValue]);

  // Fetch data from an API
  const fetchData = async () => {
    if (inputValue != "") {
      setSuggestions([]);
      if (value != 4) {
        await axios
          .get(
            `${
              config.itemsBaseUrl
            }/items/searchforaccount?searchparam=${inputValue}&iscategory=${0}&customerid=${customerID}&supplierid=${0}&locationid=${locationID}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((response) => {
            if (response.data.ResponseData.length > 0) {
              if (response != "" && response != null) {
                const data = response.data.ResponseData;
                console.log("suggestions ==>", suggestions);
                // console.log("Search Details ===>", data);
                if (data[0].ItemId > 0) {
                  setSuggestions(data);
                }
              }
            }
          })
          .catch((error) => {});
      } else {
        await axios
          .get(
            `${
              config.itemsBaseUrl
            }/items/searchforaccount?searchparam=${inputValue}&iscategory=${1}&customerid=${customerID}&supplierid=${0}&locationid=${locationID}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((response) => {
            if (response.data.ResponseData.length > 0) {
              if (response != "" && response != null) {
                const data = response.data.ResponseData;
                console.log("suggestions ==>", suggestions);
                // console.log("Search Details ===>", data);
                if (data[0].ItemId > 0) {
                  setSuggestions(data);
                }
              }
            }
          })
          .catch((error) => {});
      }
    } else {
      setSuggestions([]);
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);
    if (!value) {
      setSuggestions([]);
    }
  };

  const handleToast = () => {
    if (readonly === true) {
      toastError("Please Select a Customer First");
    }
  };

  const handleInputClick = (
    pItemId,
    pItemName,
    pVariationName,
    pUnitPrice,
    pItemQuantity,
    pDescription,
    pVariationId,
    pAttributeId,
    pModule,
    pCategoryID,
    pCategoryName,
    pCostPrice,
    pItemnumber,
    pAllowaltdescription,
    pIsItemserialnumber,
    pVariationQuantity,
    pRecallPrice,
    pTier1,
    pTier2,
    pTier3,
    pTier4,
    pTier5
    // pItemKitId
  ) => {
    if (pModule == "ItemKit") {
      axios
        .get(
          `${config.itemKitsBaseUrl}/itemkits/itemkitsitemslisting?itemkitid=${pItemId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (response != "" && response != null) {
            const data = response.data.ResponseData;
            setSuggestions(data, () => {});

            let tablesDatas = data.map((item) => ({
              SaleItemID: 0,
              ItemId: item.ItemId,
              SaleId: 0,
              UnitPrice: item.UnitPrice,
              // Price: item.UnitPrice,
              ItemName: item.ItemName,
              VariationName: item.VariationName,
              itemquantity: 1,
              ItemCurrentQuantity: item.VariationQuantity, // item.Itemquantity,
              itemdiscount: 0,
              Description: item.Description,
              VariationId: item.VariationId,
              AttributeId: item.AttributeId,
              Module: item.Module,
              Itemkitid: item.Itemkitid,
              CategoryID: item.CategoryID,
              CategoryName: item.CategoryName,
              CostPrice: item.CostPrice,
              Itemnumber: item.Itemnumber,
              Total: item.UnitPrice,
              Allowaltdescription: item.Allowaltdescription,
              IsItemserialnumber: item.IsItemserialnumber,
              RecallPrice: item.RecallPrice,
              Tier1: item.Tier1,
              Tier2: item.Tier2,
              Tier3: item.Tier3,
              Tier4: item.Tier4,
              Tier5: item.Tier5,
            }));

            setTableData([tablesDatas[0]]);
            setSuggestions([]);
          }
        })
        .catch((error) => {});
    } else {
      const selectedOption = {
        SaleItemID: 0,
        ItemId: pItemId,
        SaleId: 0,
        UnitPrice: value == 4 ? 0 : pUnitPrice,
        // Price: pUnitPrice,
        ItemName: pItemName,
        VariationName: pVariationName,
        itemquantity: 1,
        ItemCurrentQuantity: pVariationQuantity, //pItemQuantity,
        itemdiscount: 0,
        Description: pDescription,
        VariationId: pVariationId,
        AttributeId: pAttributeId,
        Module: pModule,
        Itemkitid: 0,
        CategoryID: pCategoryID,
        CategoryName: pCategoryName,
        CostPrice: pCostPrice,
        Itemnumber: pItemnumber,
        Total: value == 4 ? 0 : pUnitPrice,
        Allowaltdescription: pAllowaltdescription,
        IsItemserialnumber: pIsItemserialnumber,
        RecallPrice: pRecallPrice,
        Tier1: pTier1,
        Tier2: pTier2,
        Tier3: pTier3,
        Tier4: pTier4,
        Tier5: pTier5,
        // ItemKitId: pItemId
      };
      setSuggestions([selectedOption]);
      setTableData([selectedOption]);
    }

    setInputValue("");
    setSuggestions([]);
  };

  console.log(tableData, "tableDatas");

  useEffect(() => {
    const locationItemData = tableData.filter((locationItem) => {
      return locationItem.ItemId !== "";
    });

    if (value == 4) {
      callbackaccount(locationItemData);
    } else {
      callback(locationItemData);
    }
  }, [tableData]);

  // function calculateItemTax(total, taxPercent, stateLength) {
  //   return (total * taxPercent) / 100 / stateLength;
  // }

  // function calculateOtherTax(total, taxPercent, stateLength, taxXml) {
  //   const uniqueTaxItemIds = [...new Set(taxXml.map((item) => item.TaxItemId))];
  //   const uniqueTaxItemCount = uniqueTaxItemIds.length;
  //   return (total * taxPercent) / 100 / (stateLength - uniqueTaxItemCount);
  // }

  // function calculateTax{
  //   let taxAmount = 0;

  //   // if (tax.type === "itemTax") {
  //   //   taxAmount = (totalRef.current * tax.TaxPercent) / 100 / statenew.length;
  //   // } else {
  //   //   const uniqueTaxItemIds = [
  //   //     ...new Set(taxXml.map((item) => item.TaxItemId)),
  //   //   ];
  //   //   const nonDuplicateStatesCount = statenew.length - uniqueTaxItemIds.length;
  //   //   taxAmount =
  //   //     (totalRef.current * tax.TaxPercent) / 100 / nonDuplicateStatesCount;
  //   // }

  //   return taxAmount;
  // };
  console.log(suggestions, "<========suggestions");

  return (
    <div className="">
      <form>
        <div className="">
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              <Link to="/manage-items">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fillRule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  />
                </svg>
              </Link>
            </span>

            <input
              type="text"
              className="form-control"
              placeholder={
                value == 4
                  ? "Select Category"
                  : "Type item name or scan barcode"
              }
              value={inputValue}
              onChange={handleInputChange}
              onClick={handleToast}
              disabled={disabled}
              readOnly={readonly}
            />
          </div>
        </div>
        {suggestions?.length > 0 ? (
          <>
            <div className="dropdown">
              <ul
                className="dropdown-menu w-100 show"
                style={{ "max-height": "500px", overflow: "auto" }}
              >
                {suggestions?.map((item) => (
                  <li
                    className="border-bottom"
                    key={item.ItemId}
                    onClick={() =>
                      handleInputClick(
                        item.ItemId,
                        item.ItemName,
                        item.VariationName,
                        +item.UnitPrice,
                        item.Itemquantity,
                        item.Description,
                        item.VariationId,
                        item.AttributeId,
                        item.Module,
                        item.CategoryID,
                        item.CategoryName,
                        item.CostPrice,
                        item.Itemnumber,
                        item.Allowaltdescription,
                        item.IsItemserialnumber,
                        item.VariationQuantity,
                        item.RecallPrice,
                        item.Tier1,
                        item.Tier2,
                        item.Tier3,
                        item.Tier4,
                        item.Tier5

                        // item.ItemKitId
                      )
                    }
                  >
                    {value == 4 && (
                      <Link
                        key={item.ItemId}
                        href="#"
                        className="dropdown-item"
                        data-name={item.ItemName?.toLowerCase()}
                      >
                        <img
                          src={item.ImageName}
                          onError={(e) => {
                            e.currentTarget.src = Noimage;
                          }}
                          alt={item.ItemName}
                          className="img-thumbnail rounded-circle m-2"
                          width="55"
                          height="55"
                        />
                        <div className="customer-info">
                          <strong className="name word-break-data">
                            {item.ItemName}{" "}
                            {item.VariationName
                              ? `(${item.VariationName})`
                              : ""}
                            <Badge
                              className="ml-auto"
                              variant="primary"
                              style={{ position: "absolute", right: "5px" }}
                            >
                              {item.Module}
                            </Badge>
                          </strong>

                          <div>Account Type: {item.AccountTypeName}</div>
                          <div>{item.AccountDeatilsTypeName}</div>
                          {/* Add any other customer details here */}
                        </div>
                      </Link>
                    )}

                    {value != 4 && (
                      <Link
                        key={item.ItemId}
                        href="#"
                        className="dropdown-item"
                        data-name={item.ItemName?.toLowerCase()}
                      >
                        <img
                          src={item.ImageName}
                          onError={(e) => {
                            e.currentTarget.src = Noimage;
                          }}
                          alt={item.ItemName}
                          className="img-thumbnail rounded-circle m-2"
                          width="55"
                          height="55"
                        />
                        <div className="customer-info">
                          <strong className="name word-break-data">
                            {item.ItemName}{" "}
                            {item.VariationName
                              ? `(${item.VariationName})`
                              : ""}
                            <Badge
                              className="ml-auto"
                              variant="primary"
                              style={{ position: "absolute", right: "5px" }}
                            >
                              {item.Module}
                            </Badge>
                          </strong>
                          <div>
                            {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)} |
                        Promo Price: {parseFloat(item.PromoPrice).toFixed(2)}| */}
                            {/* Unit Price: {parseFloat(item.UnitPrice).toFixed(2)} | Qty: {parseInt(item.Itemquantity)} */}
                            Unit Price: {parseFloat(item.UnitPrice).toFixed(2)}{" "}
                            | Qty: {parseInt(item.VariationQuantity)}
                          </div>
                          <div>Categories: {item.CategoryName}</div>
                          {/* Add any other customer details here */}
                        </div>
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </>
        ) : null}
      </form>
    </div>
  );
};

export default ManageSale;
